<template>
  <div class="reservation-messages">
    <div class="rm-header">
      <!-- Las pestañas ya no encogen para caber: cuando no caben, el carril se
           desplaza. Encoger las siete a la vez dejaba el texto pegado al icono y a la
           insignia, y por debajo de 560px partía la barra en dos filas. -->
      <div class="rm-tabs-carril" :class="{ 'tiene-izq': puedeIzquierda, 'tiene-der': puedeDerecha }">
        <button
          v-show="puedeIzquierda"
          class="rm-flecha rm-flecha--izq"
          type="button"
          aria-label="Ver las pestañas anteriores"
          @click="desplazarPestanas(-1)"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
        </button>

        <div ref="carrilPestanas" class="rm-tabs" @scroll.passive="medirCarril">
        <button
          class="rm-tab"
          :class="{ active: activeTab === 'whatsapp' }"
          type="button"
          @click="switchTab('whatsapp')"
        >
          <span class="tab-icon tab-icon-whatsapp">
            <div class="link-waba-img" @click.stop>
              <a href="#" class="whatsapp-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
                </svg>
              </a>
            </div>
          </span>
          <span>WhatsApp</span>
        </button>

        <button
          v-if="showCallsTab"
          class="rm-tab"
          :class="{ active: activeTab === 'llamadas' }"
          type="button"
          @click="switchTab('llamadas')"
        >
          <span class="tab-icon">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.3 1.1l-2.1 2.1z"/></svg>
          </span>
          <span>{{ $t("reservationConversations.tabs.calls") }}</span>
          <span v-if="callsList.length" class="rm-calls-count">{{ callsList.length }}</span>
        </button>

        <button
          v-if="showWebTab"
          class="rm-tab"
          :class="{ active: activeTab === 'web' }"
          type="button"
          @click="switchTab('web')"
        >
          <span class="tab-icon tab-icon-web">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </span>
          <!-- "Web" a secas: el icono ya dice que son mensajes, y con 5-6 pestañas cada
               carácter cuenta para que la fila no se parta en dos. -->
          <span>{{ $t("reservationConversations.tabs.web") }}</span>
        </button>

        <!-- Booking dejó de enviar el teléfono del huésped, así que en sus reservas
             WhatsApp casi nunca sirve y el canal por el que de verdad se habla es el
             suyo: su pestaña va PRIMERA. Se hace con `order` y no moviendo el marcado
             para no tener el mismo botón duplicado en dos sitios, que acabaría
             separándose con el tiempo. -->
        <button
          v-if="showOtaTab"
          class="rm-tab"
          :class="{ active: activeTab === 'otas' }"
          :style="otaPrimero ? { order: -1 } : null"
          type="button"
          @click="switchTab('otas')"
        >
          <span v-if="showOtaIcon" class="tab-icon">
            <IconOta :channel_id="otaChannelId" :styleIcon="22" />
          </span>
          <span>{{ otaTabLabel }}</span>
        </button>
        <button
          v-if="showCheckinTab"
          class="rm-tab"
          :class="{ active: activeTab === 'checkin' }"
          type="button"
          @click="switchTab('checkin')"
        >
          {{ $t("reservationConversations.tabs.checkins") }}
          <span
            v-if="checkinStatus.total > 0"
            class="checkin-status-badge"
            :class="checkinStatus.badgeClass"
            :title="checkinStatus.tooltip"
          >
            <svg v-if="checkinStatus.isResolved" width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 6.5L4.8 9.5L10 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else width="9" height="9" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.8"/>
              <path d="M6 3.5V6.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="6" cy="8.5" r="0.6" fill="currentColor"/>
            </svg>
            <span class="checkin-badge-count">{{ checkinStatus.done }}/{{ checkinStatus.total }}</span>
          </span>
        </button>

        <button
          v-if="showChargesTab"
          class="rm-tab"
          :class="{ active: activeTab === 'charges' }"
          type="button"
          @click="switchTab('charges')"
        >
          {{ $t("reservationConversations.tabs.charges") }}
        </button>

        <button
          v-if="showNotesTab"
          class="rm-tab"
          :class="{ active: activeTab === 'note' }"
          type="button"
          @click="switchTab('note')"
        >
          {{ $t("reservationConversations.tabs.notes") }}
        </button>
        </div>

        <button
          v-show="puedeDerecha"
          class="rm-flecha rm-flecha--der"
          type="button"
          aria-label="Ver las pestañas siguientes"
          @click="desplazarPestanas(1)"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
        </button>
      </div>
    </div>

    <div class="rmc-body">
      <div class="rm-panel">
        <template v-if="activeTab === 'whatsapp' || activeTab === 'web'">
          <div v-if="!hasActiveConversation" class="rm-list-view">
            <div v-if="limitedMode" class="limited-mode-banner">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
              </svg>
              <span>{{ $t("reservationConversations.banners.limitedMode") }}</span>
            </div>

            <div v-if="rejectedMode" class="rejected-mode-banner">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <span>{{ $t("reservationConversations.banners.rejectedMode") }}</span>
            </div>

            <div v-if="currentChats && currentChats.length" class="search-bar">
              <div class="search-input-wrapper">
                <span class="search-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7" />
                    <line x1="16.5" y1="16.5" x2="21" y2="21" />
                  </svg>
                </span>
                <input
                  v-model="searchQuery"
                  type="text"
                  class="search-input"
                  :placeholder="$t('reservationConversations.search.placeholder')"
                />
                <button v-if="searchQuery" type="button" class="clear-btn" @click="searchQuery = ''">×</button>
              </div>
            </div>

            <div v-if="!currentChats || !currentChats.length" class="empty-state">
              <div class="empty-badge">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.3A8.5 8.5 0 1 1 21 11.5z" />
                </svg>
              </div>
              <h4>{{ $t("reservationConversations.list.emptyTitle") }}</h4>
              <p>{{ $t("reservationConversations.list.emptyText") }}</p>
            </div>

            <template v-else>
              <div v-if="filteredChats.length === 0" class="empty-state empty-filter">
                <div class="empty-icon">
                  <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#cccccc">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h18M6 9l4.5 4.5v6l3-2v-4L18 9" />
                  </svg>
                </div>
                <h4>{{ $t("reservationConversations.list.noResultsTitle") }}</h4>
                <p>{{ $t("reservationConversations.list.noResultsText") }}</p>
              </div>

              <div v-else class="notifications-list">
                <div
                  v-for="chat in filteredChats"
                  :key="chat.id || chat.chat_id || chat.uuid || chat.checkin_id"
                  class="chat-list-item"
                  :class="{ unread: isChatUnread(chat), active: activeChatKey === getChatKey(chat) }"
                  @click="openConversation(chat)"
                >
                  <div class="chat-avatar">
                    <span>{{ getInitials(getGuestFullName(chat)) }}</span>
                  </div>

                  <div class="chat-main">
                    <div class="chat-top-row">
                      <h4 class="chat-name">{{ getGuestFullName(chat) }}</h4>
                      <span class="chat-time">{{ prettyTime(chat.timestamp || chat.last_message_at) }}</span>
                    </div>

                    <div v-if="getChatPhone(chat)" class="chat-phone-row">
                      <span class="chat-phone">{{ getChatPhone(chat) }}</span>
                    </div>

                    <div class="chat-bottom-row">
                      <p class="chat-preview">{{ truncateMessage(chat.message || chat.last_message_preview) }}</p>

                      <!-- El distintivo de «la atiende la IA» solo si de verdad la
                           atiende: con el Agente apagado en la propiedad, no. -->
                      <div
                        v-if="!esManualDe(chat)"
                        class="chat-mode-badge auto-mode"
                        :title="$t('reservationConversations.list.aiActiveTitle')"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          style="width: 22px; height: 22px"
                        >
                          <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
                          <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
                          <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div v-if="isChatUnread(chat)" class="chat-unread-dot"></div>
                </div>
              </div>
            </template>

            <div v-if="currentChats && currentChats.length" class="bot-modal-footer">
              <Button
                :tooltip="$t('reservationConversations.list.markAllRead')"
                class="icon-btn outline"
                @click="markAllAsRead"
                :disabled="!hasUnreadNotifications"
              >
                <svg style="width: 20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
                </svg>
              </Button>
            </div>
          </div>

          <div v-else class="rm-conversation-view">
            <div class="chat-header">
              <button type="button" class="back-btn" @click="backToList">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>

              <div class="header-center">
                <h2 class="user-name">{{ activeGuestName }}</h2>
                <!-- La ventana de 24h es de WhatsApp; en el canal web NO aplica (siempre abierto). -->
                <small v-if="activeTab !== 'web' && conversationStatus && conversationStatus.hours_remaining" class="window-timer">
                  {{ $t("reservationConversations.conversation.windowTimer", { hours: Math.round(conversationStatus.hours_remaining) }) }}
                </small>
              </div>

              <!-- Canal web: botón para copiar el link del Portal de Estancia (gestión). -->
              <button
                v-if="activeTab === 'web' && stayPortalLink"
                type="button"
                class="copy-portal-btn"
                :title="copiedPortalLink ? $t('reservationConversations.conversation.copyPortalCopied') : $t('reservationConversations.conversation.copyPortalTooltip')"
                @click="copyStayPortalLink"
              >
                <svg v-if="!copiedPortalLink" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
                <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>{{ copiedPortalLink ? $t('reservationConversations.conversation.copiedShort') : $t('reservationConversations.conversation.copyLinkShort') }}</span>
              </button>
            </div>

            <!-- Barra de aviso: una línea pegada al borde; ellipsis + tooltip si se pasa -->
            <template v-if="conversationAlerts.length && activeTab === 'whatsapp'">
              <div
                v-for="(alert, idx) in conversationAlerts"
                :key="'alert-' + idx"
                class="ca-bar"
                :class="alert.type"
                :data-tip="alert.message"
              >
                <span class="ca-bar__icon">
                  <svg v-if="alert.icon === 'clock'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1">
                    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                  </svg>
                  <svg v-else-if="alert.icon === 'payment'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
                  </svg>
                  <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </span>
                <span class="ca-bar__text">{{ alert.short || alert.message }}</span>
                <span class="ca-bar__info">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </span>
              </div>
            </template>

            <div
              class="chat-body"
              ref="chatContainer"
              @scroll="handleScroll"
              @dragover.prevent="onDragOver"
              @dragenter.prevent="onDragEnter"
              @dragleave="onDragLeave"
              @drop.prevent="onDrop"
            >
              <div v-if="isDragOver" class="drop-overlay">
                <div class="drop-overlay-inner">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  <p class="drop-text">{{ $t("reservationConversations.conversation.dropToAttach") }}</p>
                </div>
              </div>

              <!-- Mientras llega el historial completo mostramos su silueta en vez de
                   pintar primero el trozo que ya teníamos en la lista y saltar después:
                   ese salto es lo que hacía que el chat "abriera de golpe". -->
              <transition name="rm-fade">
                <div v-if="conversationLoading" class="chat-skeleton" aria-hidden="true">
                  <div
                    v-for="sk in skeletonBubbles"
                    :key="'sk-' + sk.id"
                    class="sk-row"
                    :class="sk.side"
                  >
                    <span class="sk-bubble" :style="{ width: sk.width }"></span>
                  </div>
                </div>
              </transition>

              <template v-if="!conversationLoading && mostrar && visibleMessages.length">
                <div class="messages-wrapper">
                  <div
                    v-for="(mensaje, index) in visibleMessages"
                    :key="messageKey(mensaje, index)"
                    class="message-row"
                    :class="[mensaje.role]"
                  >
                    <div
                      class="message-card"
                      :class="[mensaje.role, { 'has-media': messageHasMedia(mensaje) }]"
                    >
                      <span v-if="mensaje.role === 'assistant'" class="message-sender">{{ $t("reservationConversations.conversation.senderBot") }}</span>
                      <span v-else-if="mensaje.role === 'user'" class="message-sender user">{{ $t("reservationConversations.conversation.senderGuest") }}</span>

                      <div
                        class="message-bubble"
                        :class="[
                          mensaje.role,

                        ]"
                      >
                        <div
                          v-if="mensaje.role === 'system'"
                          class="message-system-text"
                          v-html="formatSystemMessage(mensaje.content)"
                        ></div>

                        <MessageTranslate
                          v-else-if="isContentRenderable(mensaje.content)"
                          class="message-text"
                          :text="mensaje.content"
                          :property-id="reservationData && (reservationData.propiedad_id || reservationData.property_id)"
                          :formatter="(t) => formatMessage(t)"
                          :translation="tradDe(messageKey(mensaje, index))"
                        />

                        <div v-if="isImageMessage(mensaje)" class="message-media image">
                          <img :src="getMediaUrl(mensaje)" :alt="$t('reservationConversations.conversation.imageAlt')" />
                        </div>

                        <!-- Fotos que el agente le manda al huésped (`media`): hasta
                             cuatro, todas, y pulsando se abren en otra pestaña. -->
                        <div
                          v-if="galeriaMedia(mensaje).length"
                          class="message-media gallery"
                          :class="claseGaleria(mensaje)"
                        >
                          <div
                            v-for="item in galeriaMedia(mensaje)"
                            :key="item.url"
                            class="gallery-cell"
                          >
                            <video
                              v-if="item.tipo === 'video'"
                              controls
                              :src="item.url"
                              @error="marcarMediaFallida(item.url)"
                            ></video>
                            <a v-else :href="item.url" target="_blank" rel="noopener">
                              <img
                                :src="item.url"
                                :alt="$t('reservationConversations.conversation.imageAlt')"
                                loading="lazy"
                                @error="marcarMediaFallida(item.url)"
                              />
                            </a>
                          </div>
                        </div>

                        <div v-if="isAudioMessage(mensaje)" class="message-media audio">
                          <audio controls :src="getMediaUrl(mensaje)"></audio>
                        </div>

                        <div v-if="isVideoMessage(mensaje)" class="message-media video">
                          <video controls :src="getMediaUrl(mensaje)"></video>
                        </div>

                        <div v-if="isDocumentMessage(mensaje)" class="message-media document">
                          <a :href="getMediaUrl(mensaje)" target="_blank" rel="noopener" class="doc-link">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="attachment-icon">
                              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                              <path d="M14 2v6h6" />
                            </svg>
                            <span class="doc-name">{{ getDocumentName(mensaje) }}</span>
                          </a>
                        </div>

                        <div v-if="isLocationMessage(mensaje)" class="message-media location">
                          <a :href="getLocationUrl(mensaje)" target="_blank" rel="noopener" class="location-link">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                              <path d="M12 21s-6-4.35-6-10a6 6 0 0 1 12 0c0 5.65-6 10-6 10z" />
                              <circle cx="12" cy="11" r="2.5" />
                            </svg>
                            <div class="location-text">
                              <div class="location-title">{{ mensaje.content || $t("reservationConversations.conversation.locationReceived") }}</div>
                              <div class="location-subtitle">{{ formatLocationSubtitle(mensaje) }}</div>
                            </div>
                          </a>
                        </div>

                        <div v-if="mensaje.attachments && mensaje.attachments.length" class="message-attachments">
                          <div v-for="(att, i) in mensaje.attachments" :key="i" class="message-attachment">
                            <a v-if="att.url || att.link" :href="att.url || att.link" target="_blank" rel="noopener">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="attachment-icon">
                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                <path d="M14 2v6h6" />
                              </svg>
                              <span class="attachment-name">{{ att.name || $t("reservationConversations.conversation.viewFile") }}</span>
                            </a>
                          </div>
                        </div>

                        <div v-else-if="mensaje.attachment" class="message-attachment">
                          <a v-if="mensaje.attachment.url || mensaje.attachment.link" :href="mensaje.attachment.url || mensaje.attachment.link" target="_blank" rel="noopener">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="attachment-icon">
                              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                              <path d="M14 2v6h6" />
                            </svg>
                            <span class="attachment-name">{{ mensaje.attachment.name || $t("reservationConversations.conversation.viewFile") }}</span>
                          </a>
                        </div>
                      </div>

                      <!-- Fallo de entrega: label pequeño con el motivo; el texto completo en el title.
                           Un mensaje en cola por la ventana de 24 h NO sale aquí: ese lleva un
                           solo check y se entrega al aceptar la plantilla de re-contacto. -->
                      <div
                        v-if="isMessageFailed(mensaje) && !mensaje.can_retry_template"
                        class="message-fail-chip"
                        :title="getMessageErrorText(mensaje)"
                      >
                        <svg class="message-fail-chip__ico" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
                        </svg>
                        <span class="message-fail-chip__label">{{ $t("reservationConversations.conversation.notSent") }}</span>
                        <span class="message-fail-chip__sep">·</span>
                        <span class="message-fail-chip__reason">{{ messageFailureShort(mensaje) }}</span>
                      </div>


                      <div class="message-meta">
                        <span
                          v-if="shouldShowDeliveryStatus(mensaje)"
                          :class="['message-delivery-status', whatsappStatusClass(mensaje)]"
                          :title="whatsappStatusLabel(mensaje)"
                        >
                          {{ whatsappStatusChecks(mensaje) }}
                        </span>
                        <span class="message-time" :class="{ 'message-time--pending': mensaje.pending || mensaje.sending }">
                          {{ mensaje.pending || mensaje.sending ? $t('reservationConversations.conversation.sending') : formatTimestamp(mensaje.timestamp) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="isSending && isManualMode && activeTab === 'whatsapp'" class="message-row assistant">
                    <div class="message-card assistant">
                      <div class="message-bubble assistant typing">
                        <div class="typing-dots">
                          <span></span><span></span><span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div v-else class="empty-state">
                <div class="empty-badge">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.3A8.5 8.5 0 1 1 21 11.5z" />
                  </svg>
                </div>
                <h4>{{ $t("reservationConversations.conversation.emptyTitle") }}</h4>
                <p>{{ $t("reservationConversations.conversation.emptyText") }}</p>
              </div>
            </div>

            <div class="chat-footer">
              <div class="mode-toggle">
                <span class="mode-label mode-label--ai" :class="{ active: !isManualMode }">
                  <svg class="ai-agent-icon ai-agent-icon--sm" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
                    <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
                    <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
                  </svg>
                  {{ $t("reservationConversations.mode.ai") }}
                </span>
                <InputSwitch v-model="isManualMode" @change="handleModeChange" class="custom-switch" :disabled="agentNotConfigured" />
                <span class="mode-label mode-label--manual" :class="{ active: isManualMode }">
                  <svg class="ai-agent-icon ai-agent-icon--sm" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-5.33 0-8 2.67-8 4v1h16v-1c0-1.33-2.67-4-8-4z"/>
                  </svg>
                  {{ $t("reservationConversations.mode.manual") }}
                </span>

                <!-- Indicador: el Agente IA no está activo para esta propiedad -->
                <span
                  v-if="agentNotConfigured"
                  class="agent-off-chip"
                  :title="$t('reservationConversations.mode.agentInactiveTooltip')"
                >
                  <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">
                    <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 15a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm1-5.25a1 1 0 0 1-2 0V7a1 1 0 0 1 2 0z"/>
                  </svg>
                  {{ $t("reservationConversations.mode.agentInactiveChip") }}
                </span>
                <!-- El traductor, en la misma fila que el IA/Manual: no gasta un renglón
                     propio encima de la caja. La previa sigue encima de la caja. -->
                <BarraTraduccion
                  v-if="isManualMode"
                  parte="interruptor"
                  :activo="trad.activo"
                  :idioma-huesped="trad.idiomaHuesped"
                  :nombre-huesped="trad.idiomaHuesped ? tradNombreDe(trad.idiomaHuesped) : ''"
                  :mi-idioma-nombre="tradMiIdiomaNombre"
                  :salida="tradSalida"
                  :opciones="tradOpciones"
                  :hay-que-leer="tradHayQueLeer"
                  :hay-que-enviar="tradHayQueEnviar"
                  :previa="trad.previa"
                  :traduciendo="trad.traduciendo"
                  @alternar="tradAlternar"
                  @salida="(c) => tradElegirSalida(c, reservationData && reservationData.id)"
                  @enviar="tradEnviarLaPrevia"
                  @descartar="tradDescartarPrevia"
                />
              </div>
              <div v-if="isManualMode" class="input-area">
                <div v-if="showPredefinedList" class="predefined-dropdown">
                  <div class="predefined-header">
                    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                      <path fill="currentColor" d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
                    </svg>
                    <span>{{ $t("reservationConversations.composer.predefinedTitle") }}</span>
                  </div>

                  <div class="predefined-list">
                    <div
                      v-for="question in filteredQuestions"
                      :key="question.id"
                      class="predefined-item"
                      @click="selectPredefinedQuestion(question)"
                    >
                      <div class="predefined-item-question">{{ question.question }}</div>
                      <div class="predefined-item-preview">
                        {{ question.answer.substring(0, 80) }}{{ question.answer.length > 80 ? "..." : "" }}
                      </div>
                    </div>

                    <div v-if="filteredQuestions.length === 0" class="predefined-empty">
                      {{ $t("reservationConversations.composer.predefinedEmpty") }}
                    </div>
                  </div>
                </div>

                <BarraTraduccion
                  parte="previa"
                  :activo="trad.activo"
                  :idioma-huesped="trad.idiomaHuesped"
                  :nombre-huesped="trad.idiomaHuesped ? tradNombreDe(trad.idiomaHuesped) : ''"
                  :mi-idioma-nombre="tradMiIdiomaNombre"
                  :salida="tradSalida"
                  :opciones="tradOpciones"
                  :hay-que-leer="tradHayQueLeer"
                  :hay-que-enviar="tradHayQueEnviar"
                  :previa="trad.previa"
                  :traduciendo="trad.traduciendo"
                  @alternar="tradAlternar"
                  @salida="(c) => tradElegirSalida(c, reservationData && reservationData.id)"
                  @enviar="tradEnviarLaPrevia"
                  @descartar="tradDescartarPrevia"
                />

                <div class="input-row">
                  <button
                    class="input-icon-btn"
                    type="button"
                    @click="triggerFileSelect"
                    :title="$t('reservationConversations.composer.attachFile')"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                    </svg>
                  </button>

                  <textarea
                    v-model="messageText"
                    @keydown.enter.exact.prevent="alPulsarEnterEnElChat"
                    :placeholder="$t('reservationConversations.composer.inputPlaceholder')"
                    class="message-input"
                    rows="1"
                    ref="messageInput"
                    @dragover.prevent="onDragOver"
                    @dragenter.prevent="onDragEnter"
                    @dragleave="onDragLeave"
                    @drop.prevent="onDrop"
                  ></textarea>

                  <button
                    @click="sendMessage"
                    :disabled="isSending || (!messageText.trim() && !selectedFiles.length && !selectedPredefinedAttachments.length)"
                    class="send-btn"
                    type="button"
                  >
                    <svg v-if="!isSending" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                    </svg>
                    <div v-else class="send-spinner"></div>
                  </button>
                </div>

                <div v-if="selectedFiles.length || selectedPredefinedAttachments.length" class="attachments-list">
                  <div v-for="(file, index) in selectedFiles" :key="'file-' + index" class="attachment-chip">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                      <path d="M14 2v6h6" />
                    </svg>
                    <span class="file-name">{{ truncateFileName(file.name, 20) }}</span>
                    <button type="button" class="remove-file-btn" @click="removeFile(index)" :title="$t('reservationConversations.composer.removeFile')">×</button>
                  </div>

                  <div v-for="(att, idx) in selectedPredefinedAttachments" :key="'predef-' + idx" class="attachment-chip">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                      <path d="M14 2v6h6" />
                    </svg>
                    <span class="file-name">{{ truncateFileName(att.name || $t("reservationConversations.composer.fileFallback"), 20) }}</span>
                  </div>
                </div>

                <input
                  ref="fileInput"
                  type="file"
                  multiple
                  accept="image/*,application/pdf"
                  class="hidden-input"
                  @change="onFilesSelected"
                />
              </div>

              <div v-else class="auto-banner">
                <div class="auto-banner-left">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    style="width: 22px; height: 22px"
                  >
                    <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
                    <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
                    <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
                  </svg>
                  <span>{{ $t("reservationConversations.banners.autoReplying") }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="activeTab === 'llamadas'">
          <div class="rm-conversation-view">
            <div class="chat-header">
              <div class="header-center">
                <h2 class="user-name">{{ $t("reservationConversations.calls.title") }}</h2>
              </div>
            </div>
            <div class="chat-body rm-calls-body">
              <div v-if="!callsList.length" class="auto-banner ota-banner">
                <div class="auto-banner-left">
                  <span>{{ $t("reservationConversations.calls.none") }}</span>
                </div>
              </div>
              <div v-else class="rm-calls">
                <div v-for="c in callsList" :key="c.id" class="rm-call">
                  <div class="rm-call__head">
                    <span class="rm-call__phone">{{ c.caller_phone || $t('reservationConversations.calls.caller') }}</span>
                    <span v-if="c.from_this_call" class="rm-call__tag">{{ $t("reservationConversations.calls.bookedFromCall") }}</span>
                    <span class="rm-call__when">{{ callWhen(c) }}</span>
                  </div>
                  <div class="rm-call__meta">
                    <span v-if="c.listing">{{ c.listing }}</span>
                    <span v-if="c.duration_sec">· {{ callDuration(c) }}</span>
                  </div>

                  <div v-if="c.has_recording" class="rm-player">
                    <button type="button" class="rm-player__play" :disabled="callLoading(c)" :aria-label="callPlaying(c) ? $t('reservationConversations.calls.pause') : $t('reservationConversations.calls.play')" @click="playCall(c)">
                      <span v-if="callLoading(c)" class="rm-player__spin"></span>
                      <svg v-else-if="callPlaying(c)" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>
                      <svg v-else viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>
                    </button>
                    <div class="rm-player__bar" @click="seekCall($event, c)">
                      <div class="rm-player__fill" :style="{ width: callPct(c) + '%' }"></div>
                      <div class="rm-player__thumb" :style="{ left: callPct(c) + '%' }"></div>
                    </div>
                    <span class="rm-player__time">{{ fmtCallTime(callCurrent(c)) }} / {{ fmtCallTime(callTotal(c)) }}</span>
                    <a class="rm-player__dl" href="#" :title="$t('reservationConversations.calls.downloadMp3')" :aria-label="$t('reservationConversations.calls.downloadMp3')" @click.prevent.stop="downloadCall(c)">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v11m0 0l-4-4m4 4l4-4M5 20h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </a>
                  </div>
                  <div v-else class="rm-call__norec">{{ $t("reservationConversations.calls.noRecording") }}</div>

                  <!-- Resumen de la llamada (generado por IA) -->
                  <div v-if="c.summary" class="rm-call__summary">
                    <span class="rm-call__ia">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.09 5.26L20 8.27l-4 3.64L17.18 18 12 15.27 6.82 18 8 11.91l-4-3.64 5.91-1.01L12 2z"/></svg>
                      {{ $t("reservationConversations.mode.ai") }}
                    </span>
                    <span class="rm-call__summary-text">{{ c.summary }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="activeTab === 'otas'">
          <OtaMessages v-if="reservationData" :reservation-id="reservationData.id" :current-chat="mostrar" :channel-id="otaChannelId" :listing-id="(reservationData.propiedad && reservationData.propiedad.listing_id) || null" :reservation-property="reservationData.propiedad || null" />
          <div v-else class="auto-banner ota-banner">
            <div class="auto-banner-left">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5l2 2 2-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
              </svg>
              <span>{{ $t("reservationConversations.ota.noData") }}</span>
            </div>
          </div>
        </template>

        <template v-else-if="activeTab === 'checkin'">
          <div class="rm-conversation-view">
            <div class="chat-header">
              <div class="header-center">
                <h2 class="user-name">{{ $t("reservationConversations.checkins.title") }}</h2>
              </div>
            </div>
            <div class="chat-body">
              <CheckinsList
                v-if="reservationData"
                :reservation-id="checkinReservationId"
                :total-guests="checkinTotalGuests"
                :initial-checkins="reservationData.reservas || []"
                :property="reservationData.propiedad || {}"
                :reservation-data="reservationData"
                @system-action-triggered="handleSystemActionTriggered"
              />
            </div>
          </div>
        </template>

        <template v-else-if="activeTab === 'charges'">
          <div class="rm-conversation-view">
            <div class="chat-header">
              <div class="header-center">
                <h2 class="user-name">{{ $t("reservationConversations.charges.title") }}</h2>
              </div>
            </div>
            <div class="chat-body charges-body-wrapper p-0" style="padding: 16px 18px !important; overflow-y: auto;">
              <ReservationCharges v-if="reservationData" :reservationData="reservationData" @charges-changed="$emit('charges-changed')" />
              <div v-else class="auto-banner ota-banner">
                <div class="auto-banner-left">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5l2 2 2-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
                  </svg>
                  <span>{{ $t("reservationConversations.charges.noData") }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="activeTab === 'note'">
          <div class="rm-conversation-view">
            <div class="chat-header">
              <div class="header-center">
                <h2 class="user-name">{{ $t("reservationConversations.notes.title") }}</h2>
              </div>
            </div>
            <div class="chat-body notes-body-wrapper p-0">
              <ReservationNotes
                v-if="reservationData"
                :reservationData="reservationData"
                @notes-changed="$emit('charges-changed')"
              />
              <div v-else class="auto-banner ota-banner">
                <div class="auto-banner-left">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5l2 2 2-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
                  </svg>
                  <span>{{ $t("reservationConversations.notes.noData") }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import { marked } from "marked";
import axios from "axios";
import moment from "moment";
import CheckinsList from "@/components/Reservas/CheckinsList.vue";
import MessageTranslate from "@/components/chat/MessageTranslate.vue";
import OtaMessages from "@/components/Reservas/OtaMessages.vue";
import BarraTraduccion from "@/components/chat/BarraTraduccion.vue";
import traductorDeChat from "@/mixins/traductorDeChat";
import IconOta from "@/components/Reservas/IconOTABackground.vue";
import ReservationNotes from "@/components/Reservas/ReservationNotes.vue";
import ReservationCharges from "@/components/booking/ReservationCharges.vue";

export default {
  name: "ReservationMessages",
  components: {
    InputSwitch,
    Button,
    CheckinsList,
    OtaMessages,
    MessageTranslate,
    BarraTraduccion,
    IconOta,
    ReservationNotes,
    ReservationCharges,
  },

  props: {
    whatsappChats: { type: Array, default: () => [] },
    otaChats: { type: Array, default: () => [] },
    webChats: { type: Array, default: () => [] },
    reservationData: { type: Object, required: false },
    limitedMode: { type: Boolean, default: false },
    rejectedMode: { type: Boolean, default: false },
    // Destino inicial pedido por la bandeja de mensajes del nav: pestaña del canal
    // por el que escribió el huésped (whatsapp | web | otas) y, si se conoce, la
    // conversación concreta.
    initialTab: { type: String, default: null },
    initialChatId: { type: [String, Number], default: null },
  },

  data() {
    return {
      // URL de fotos que no han cargado: se ocultan en vez de dejar el icono roto.
      mediaFallidas: [],
      activeTab: "whatsapp",
      // La pestaña por defecto según el canal se decide UNA vez, al llegar la reserva.
      pestanaPorCanalHecha: false,
      // ¿Queda carril por recorrer a cada lado? Decide si se ven las flechas.
      puedeIzquierda: false,
      puedeDerecha: false,
      vigilanteDelCarril: null,
      searchQuery: "",
      mostrar: null,
      isManualMode: false,
      isChangingMode: false,
      messageText: "",
      isSending: false,
      selectedFiles: [],
      userIsAtBottom: true,
      isDragOver: false,
      activeChatKey: null,
      predefinedQuestions: [],
      showPredefinedList: false,
      filteredQuestions: [],
      selectedPredefinedAttachments: [],
      conversationStatus: null,
      copiedPortalLink: false,
      loadingConversationStatus: false,
      lastConversationStatusRequestKey: null,
      lastConversationStatusRequestAt: 0,
      activeConversationRequestId: 0,
      manualCheckinResolvedAt: null,
      // initialTab/initialChatId se aplican UNA sola vez, en cuanto la pestaña
      // esté disponible y hayan llegado los chats (todo se carga asíncrono).
      initialTargetDone: false,
      // true mientras se pide el historial completo de la conversación abierta.
      conversationLoading: false,
      // Llamadas del Agente IA de Voz asociadas a esta reserva (pestaña "Llamadas").
      callsList: [],
      callRec: { id: null, playing: false, loading: false, audio: null, current: 0, duration: 0, url: null },
    };
  },

  created() {
    this.aplicarPestanaPorCanal();
    this.applyInitialTarget();
    this.fetchCalls();
  },

  computed: {
    // Reserva COMPUESTA: el check-in es ÚNICO del grupo (vive en la línea primaria) y
    // los huéspedes esperados son los de TODA la reserva. Así los check-ins aparecen
    // "juntos" en cualquier habitación de la reserva.
    checkinReservationId() {
      const d = this.reservationData;
      if (d && d.is_group && Array.isArray(d.group_lines)) {
        const primary = d.group_lines.find((l) => l.is_primary);
        if (primary) return primary.reserva_id;
      }
      return d ? d.id : null;
    },
    checkinTotalGuests() {
      const d = this.reservationData;
      if (d && d.is_group) return d.group_guests;
      return d ? d.cantidad_huesped : 0;
    },
    // ¿El Agente IA NO está activo para esta propiedad/anuncio? (automation_allowed=false)
    // En ese caso el chat siempre estará en manual y no se puede activar la IA aquí.
    agentNotConfigured() {
      const chat = this.mostrar || {};
      // Si el backend aún no envía el campo (chats viejos), no marcamos nada.
      if (chat.automation_allowed === undefined || chat.automation_allowed === null) return false;
      return chat.automation_allowed === false;
    },

    showOtaTab() {
      // La pestaña de la OTA se muestra SIEMPRE que la reserva venga de una (igual que
      // WhatsApp y Conserje web, que tampoco dependen de limitedMode). Antes se ocultaba
      // en reservas canceladas/rechazadas: el anfitrión abría el drawer de una reserva
      // de Booking o Airbnb y su conversación había desaparecido. Leer el historial de
      // una reserva cancelada es justo cuando más falta hace.
      return this.canShowOtaTab;
    },

    showWebTab() {
      // En la vista de reserva SIEMPRE visible (aunque no haya conversación aún),
      // para poder INICIAR el chat del Conserje con el huésped.
      return !!(this.reservationData && this.reservationData.id);
    },

    // Pestaña "Llamadas": solo si hay llamadas de voz asociadas a esta reserva.
    showCallsTab() {
      return this.callsList.length > 0;
    },

    showCheckinTab() {
      return !this.limitedMode && !this.rejectedMode;
    },

    checkinStatus() {
      const total = Number(this.reservationData?.cantidad_huesped || 0);
      const done  = (this.reservationData?.reservas || []).length;
      const manualResolvedAt =
        this.manualCheckinResolvedAt ||
        this.reservationData?.first_checkin_info_sent_at ||
        null;
      const isComplete = total > 0 && done >= total;
      const isManuallyResolved = !isComplete && Boolean(manualResolvedAt);

      return {
        total,
        done,
        isComplete,
        isManuallyResolved,
        isResolved: isComplete || isManuallyResolved,
        badgeClass: isComplete
          ? "checkin-status-badge--ok"
          : isManuallyResolved
            ? "checkin-status-badge--manual"
            : "checkin-status-badge--pending",
        tooltip: isComplete
          ? this.$t("reservationConversations.checkinBadge.allCompleted")
          : isManuallyResolved
            ? this.$t("reservationConversations.checkinBadge.manuallyResolved")
            : this.$t("reservationConversations.checkinBadge.progress", { done, total }),
      };
    },

    // Una reserva CANCELADA sigue llevando cargos: las políticas de cancelación
    // cobran un porcentaje y el anfitrión tiene que poder cobrarlo y facturarlo. Se
    // siguen ocultando los estados que nunca llegaron a ser una reserva (solicitud sin
    // aprobar, intento de pago, rechazada, caducada), que es lo que limitedMode marca.
    isCancelledReservation() {
      const s = String(this.reservationData?.status || '').toLowerCase();
      return ['cancelled', 'canceled', 'cancelado', 'cancelada'].includes(s);
    },

    showChargesTab() {
      if (this.isCancelledReservation) return true;
      return !this.limitedMode && !this.rejectedMode;
    },

    showNotesTab() {
      return true;
    },

    /** La reserva cuyo idioma busca el traductor. */
    tradReservaId() {
      return (this.reservationData && this.reservationData.id) || null;
    },

    visibleMessages() {
      if (!this.mostrar || !this.mostrar.chat_history) return [];
      return this.mostrar.chat_history.filter((msg) => {
        if (!msg) return false;
        if (msg.role === "meta") return false;
        if (this.isInternalSystemMessage(msg)) return false;
        return true;
      });
    },

    conversationAlerts() {
      if (!this.conversationStatus) return [];
      const alerts = [];

      // La ventana de 24h cerrada NO se avisa: es el estado normal de casi cualquier
      // reserva hasta que el huésped escribe, el sistema ya envía la plantilla de
      // contacto por su cuenta, y la barra en rojo hacía pensar que algo fallaba.
      // Los avisos de CUENTA (pago, revisión, número desconectado) sí se mantienen,
      // porque esos sí requieren que el anfitrión haga algo.

      if (!this.conversationStatus.account_ok) {
        [
          ...(this.conversationStatus.errors || []),
          ...(this.conversationStatus.warnings || []).filter((warning) =>
            warning.type === "account_review" ||
            warning.type === "payment_issue" ||
            warning.type === "phone_disconnected"
          ),
        ].forEach((err) => {
          alerts.push({
            type: "error",
            icon: err.type === "payment_issue" ? "payment" : "alert",
            short: err.type === "payment_issue" ? this.$t("reservationConversations.alerts.paymentIssue") : this.$t("reservationConversations.alerts.whatsappUnavailable"),
            message: err.message,
          });
        });
      }

      (this.conversationStatus.warnings || [])
        .filter((warning) => warning.type === "quality_rating" || warning.type === "quality_warning")
        .forEach((warning) => {
          alerts.push({
            type: "warning",
            icon: "alert",
            short: this.$t("reservationConversations.alerts.qualityReduced"),
            message: warning.message,
          });
        });

      return alerts;
    },

    canSendFreeform() {
      if (!this.conversationStatus) return true;
      return this.conversationStatus.can_send_freeform === true;
    },

    currentChats() {
      if (this.activeTab === "web") return this.webChats;
      return this.activeTab === "whatsapp" ? this.whatsappChats : this.otaChats;
    },

    filteredChats() {
      const list = this.currentChats || [];
      const qRaw = this.searchQuery || "";
      const q = qRaw.trim().toLowerCase();
      const qDigits = qRaw.replace(/\D/g, "");

      if (!q && !qDigits) return list;

      return list.filter((chat) => {
        const phone = (chat.phoneDigits || chat.phone_number || "").toString().replace(/\D/g, "");
        const guestName = (
          chat.senderName ||
          chat.guest_name ||
          chat.guest_full_name ||
          chat.nombre ||
          (chat.raw && chat.raw.nombre) ||
          ""
        ).toString().toLowerCase();

        const reservationCode = (
          (
            chat.reservation_code ||
            chat.reservationCode ||
            (chat.raw && (chat.raw.reservation_code || chat.raw.reservationCode))
          ) ?? ""
        ).toString().toLowerCase();

        return (
          (q && guestName.includes(q)) ||
          (q && reservationCode.includes(q)) ||
          (qDigits && phone.includes(qDigits))
        );
      });
    },

    hasUnreadNotifications() {
      return (this.currentChats || []).some((chat) => this.isChatUnread(chat));
    },

    hasActiveConversation() {
      if (this.activeTab !== "whatsapp" && this.activeTab !== "otas" && this.activeTab !== "web") return false;
      return !!this.mostrar;
    },

    activeGuestName() {
      return this.mostrar ? this.getGuestFullName(this.mostrar) : this.$t("reservationConversations.guestFallback");
    },

    // Link del Portal de Estancia (gestión de la reserva) para el botón de copiar
    // del canal web. El slug es cosmético (el portal resuelve por uid).
    stayPortalLink() {
      const base = (process.env.VUE_APP_GUEST || "").replace(/\/+$/, "");
      const uid = this.reservationData?.uid;
      if (!base || !uid) return "";
      return `${base}/stay/reserva/${uid}`;
    },

    otaChannelId() {
      const reservation = this.reservationData || {};
      return reservation.id_channel || reservation.channel_id || (reservation.channel && reservation.channel.id) || null;
    },

    // El nombre de la OTA en vez de un genérico "Mensajes": junto a "WhatsApp" y "Web"
    // dice de QUÉ canal es la pestaña (y es más corto, que la fila va justa).
    otaTabLabel() {
      if (this.otaChannelId === 2) return "Airbnb";
      if (this.otaChannelId === 1) return "Booking";
      if (this.otaChannelId === 4) return "Expedia";
      return "OTA";
    },

    showOtaIcon() {
      return this.canShowOtaTab;
    },

    // OTAs cuyo chat se puede LEER Y CONTESTAR desde la reserva.
    //
    // Es una lista corta a propósito, no "todas las que traigan hilo": aquí solo entran
    // las que de verdad aceptan que les escribamos de vuelta. Expedia se había quedado
    // fuera porque en su día no dejaba responder; sus mensajes llegaban a la bandeja y
    // se guardaban con su reserva y su hilo, pero la pestaña no se pintaba, así que en
    // la ficha de la reserva no había ni rastro de la conversación. Ya responde, así
    // que entra.
    //
    // Vrbo (3) y B&B Italy (6) NO entran: sus mensajes se siguen guardando, pero no se
    // ofrece contestar por ahí hasta comprobar que el canal lo acepta. Abrir la pestaña
    // de una OTA que no admite respuesta es peor que no tenerla: el anfitrión escribe,
    // se queda tranquilo, y el huésped nunca lo recibe.
    canShowOtaTab() {
      return [1, 2, 4].includes(Number(this.otaChannelId));
    },

    /**
     * ¿La conversación de la OTA manda sobre WhatsApp en esta reserva?
     *
     * Booking cambió su política y dejó de enviar el teléfono del huésped. Sin
     * teléfono no hay WhatsApp, así que dejar esa pestaña delante y abierta llevaba
     * al anfitrión a un chat vacío mientras el huésped le escribía por Booking.
     *
     * Solo Booking: Airbnb y Expedia siguen llegando con teléfono.
     */
    otaPrimero() {
      return this.canShowOtaTab && Number(this.otaChannelId) === 1;
    },

    // Silueta del hilo mientras carga. Anchos fijos (no aleatorios) para que la
    // silueta no "baile" en cada repintado de Vue.
    skeletonBubbles() {
      return [
        { id: 1, side: "in", width: "62%" },
        { id: 2, side: "out", width: "48%" },
        { id: 3, side: "out", width: "72%" },
        { id: 4, side: "in", width: "40%" },
        { id: 5, side: "out", width: "56%" },
      ];
    },
  },

  /* El traductor del chat: trae a mi idioma lo que escribe el huésped y, antes
     de contestar, enseña en qué idioma le va a llegar. El mismo de la bandeja. */
  mixins: [traductorDeChat],

  watch: {
    // Recarga las llamadas asociadas cuando cambia la reserva mostrada.
    "reservationData.id"(id) {
      this.fetchCalls();
    },

    /* En qué idioma habla este huésped. Se pregunta al abrir la reserva —también
       la primera vez, por eso es inmediato— y no al escribir: la barra tiene
       que decirlo antes de la primera letra. */
    tradReservaId: {
      immediate: true,
      handler(id) {
        this.tradCargarIdioma(id || null);
      },
    },

    /* Lo que escribe el huésped, traído a mi idioma en cuanto entra: de todo el
       hilo y en un solo viaje, no uno por mensaje. */
    visibleMessages: {
      immediate: true,
      handler(lista) {
        this.tradTraerLoQueFalta(lista, (m) => {
          if (!m || m.role !== "user" || !this.isContentRenderable(m.content)) return null;
          const i = (lista || []).indexOf(m);
          return { id: this.messageKey(m, i), texto: String(m.content) };
        });
      },
    },

    "trad.activo"() {
      const lista = this.visibleMessages;
      this.tradTraerLoQueFalta(lista, (m) => {
        if (!m || m.role !== "user" || !this.isContentRenderable(m.content)) return null;
        const i = (lista || []).indexOf(m);
        return { id: this.messageKey(m, i), texto: String(m.content) };
      });
    },

    messageText(val) {
      /* Si se sigue escribiendo, la previa de antes ya no vale. */
      this.tradAlEscribir(val);
    },

    rejectedMode(val) {
      if (!val) return;
      const echaDeCargos = this.activeTab === "charges" && !this.isCancelledReservation;
      if (this.activeTab === "otas" || this.activeTab === "checkin" || echaDeCargos) {
        this.activeTab = "whatsapp";
      }
    },

    limitedMode(val) {
      if (!val) return;
      const echaDeCargos = this.activeTab === "charges" && !this.isCancelledReservation;
      if (this.activeTab === "otas" || this.activeTab === "checkin" || echaDeCargos) {
        this.activeTab = "whatsapp";
      }
    },

    // reservationData y las listas de chats llegan asíncronas: reintentamos el
    // destino inicial (pestaña + conversación) hasta que se pueda aplicar.
    reservationData() {
      this.aplicarPestanaPorCanal();
      this.applyInitialTarget();
    },

    webChats() {
      this.applyInitialTarget();
    },

    whatsappChats: {
      deep: true,
      handler(newChats) {
        if (!Array.isArray(newChats)) return;

        this.applyInitialTarget();

        if (this.activeTab === "whatsapp" && !this.mostrar && newChats.length === 1) {
          this.openConversation(newChats[0]);
          return;
        }

        if (this.activeTab !== "whatsapp" || !this.mostrar || !this.activeChatKey) return;

        const updatedChat = newChats.find((chat) => this.getChatKey(chat) === this.activeChatKey);

        if (!updatedChat) {
          this.backToList();
          return;
        }

        const hasFullHistory = this.mostrar.__full_history_loaded === true;
        if (!hasFullHistory) {
          const newHistory = this.getChatHistory(updatedChat);
          const merged = this._mergeHistories(
            Array.isArray(newHistory) ? newHistory.map((m) => ({ ...m })) : [],
            this.mostrar.chat_history || []
          );
          this.$set(this.mostrar, "chat_history", merged);
        }

        if (updatedChat.is_active !== undefined && updatedChat.is_active !== this.mostrar.is_active) {
          this.$set(this.mostrar, "is_active", updatedChat.is_active);
        }

        if (updatedChat.last_message_at && updatedChat.last_message_at !== this.mostrar.last_message_at) {
          this.$set(this.mostrar, "last_message_at", updatedChat.last_message_at);
          if (hasFullHistory) {
            this._refreshMostrar({ chat: updatedChat });
          } else {
            this.fetchConversationStatus({ force: true });
          }
        }

        if (this.userIsAtBottom) {
          this.$nextTick(() => this.scrollToBottom(false));
        }
      },
    },

    "mostrar.chat_history": {
      deep: false,
      handler(newVal, oldVal) {
        if (!this.mostrar || !newVal) return;
        if (Array.isArray(newVal) && newVal.length !== (oldVal?.length || 0)) {
          this.fetchConversationStatus({ force: true });
        }
        if (this.userIsAtBottom && newVal.length !== oldVal?.length) {
          this.$nextTick(() => this.scrollToBottom(false));
        }
      },
    },

    isManualMode(val) {
      if (val) this.$nextTick(() => this.$refs.messageInput?.focus());
    },

    messageText(newVal) {
      this.handlePredefinedQuestionsVisibility(newVal);
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);

    /* El carril cambia de ancho sin que cambie la ventana: el cajón se abre, se
       ensancha, o aparece la pestaña de Llamadas. Un ResizeObserver lo ve todo;
       escuchar `resize` de la ventana no. */
    this.$nextTick(() => {
      const el = this.$refs.carrilPestanas;
      if (el && typeof ResizeObserver !== "undefined") {
        this.vigilanteDelCarril = new ResizeObserver(() => this.medirCarril());
        this.vigilanteDelCarril.observe(el);
      }
      this.medirCarril();
    });
    // Escuchar eventos de socket reenviados por App.vue vía $root para real-time
    if (this.$root) {
      this.$root.$on("crm-socket-conversation-payload", this._onCrmSocketPayload);
    }
    // Refresco periódico de la conversación abierta para reflejar los cambios de
    // estado de entrega/lectura (✓ → ✓✓ azul) en tiempo real, sin recargar la vista.
    this._statusPollTimer = setInterval(() => {
      if (
        !document.hidden &&
        this.activeTab === "whatsapp" &&
        this.mostrar &&
        !this.isSending
      ) {
        this._refreshMostrar();
      }
    }, 10000);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this.vigilanteDelCarril) this.vigilanteDelCarril.disconnect();
    if (this.$root) {
      this.$root.$off("crm-socket-conversation-payload", this._onCrmSocketPayload);
    }
    if (this._statusPollTimer) clearInterval(this._statusPollTimer);
    this.stopCallRecording();
  },

  methods: {
    // ----- Llamadas de voz asociadas a la reserva (pestaña "Llamadas") -----
    fetchCalls() {
      const id = this.reservationData && this.reservationData.id;
      if (!id) { this.callsList = []; return; }
      axios
        .get(`/voice-agent/reservation/${id}/calls`)
        .then(({ data }) => { this.callsList = (data && data.calls) || []; })
        .catch(() => { this.callsList = []; });
    },
    callWhen(c) {
      if (!c.started_at) return "";
      const d = new Date(c.started_at);
      return d.toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
    },
    callDuration(c) {
      const s = Number(c.duration_sec || 0);
      if (!s) return "";
      const m = Math.floor(s / 60);
      const ss = s % 60;
      return m > 0 ? `${m} min ${ss}s` : `${ss}s`;
    },
    stopCallRecording() {
      const a = this.callRec.audio;
      if (a) { try { a.pause(); } catch (e) { /* noop */ } }
      if (this.callRec.url) { try { URL.revokeObjectURL(this.callRec.url); } catch (e) { /* noop */ } }
      this.callRec = { id: null, playing: false, loading: false, audio: null, current: 0, duration: 0, url: null };
    },
    async loadCallRecording(c) {
      this.stopCallRecording();
      this.callRec.id = c.id;
      this.callRec.loading = true;
      try {
        const { data } = await axios.get(`/voice-agent/call-recording/${c.id}`, { responseType: "blob" });
        const url = URL.createObjectURL(data);
        const audio = new Audio(url);
        audio.preload = "metadata";
        audio.addEventListener("loadedmetadata", () => { this.callRec.duration = isFinite(audio.duration) ? audio.duration : 0; });
        audio.addEventListener("timeupdate", () => { this.callRec.current = audio.currentTime || 0; });
        audio.addEventListener("ended", () => { this.callRec.playing = false; this.callRec.current = 0; try { audio.currentTime = 0; } catch (e) { /* noop */ } });
        audio.addEventListener("error", () => { this.stopCallRecording(); });
        this.callRec.audio = audio;
        this.callRec.url = url;
        await audio.play();
        this.callRec.playing = true;
      } catch (e) {
        this.stopCallRecording();
      } finally {
        this.callRec.loading = false;
      }
    },
    toggleCallPlay() {
      const a = this.callRec.audio;
      if (!a) return;
      if (this.callRec.playing) { a.pause(); this.callRec.playing = false; }
      else { a.play().then(() => { this.callRec.playing = true; }).catch(() => { /* noop */ }); }
    },
    isCallActive(c) { return this.callRec.id === c.id; },
    callPlaying(c) { return this.isCallActive(c) && this.callRec.playing; },
    callLoading(c) { return this.isCallActive(c) && this.callRec.loading; },
    callCurrent(c) { return this.isCallActive(c) ? this.callRec.current : 0; },
    callTotal(c) {
      if (this.isCallActive(c) && this.callRec.duration) return this.callRec.duration;
      return Number(c.duration_sec || 0); // duración del backend antes de cargar el audio
    },
    callPct(c) {
      const total = this.callTotal(c);
      return this.isCallActive(c) && total > 0 ? Math.min(100, (this.callRec.current / total) * 100) : 0;
    },
    // Un solo click: si la llamada no está cargada, la carga y reproduce; si ya, play/pausa.
    playCall(c) {
      if (this.callRec.id === c.id) { this.toggleCallPlay(); return; }
      this.loadCallRecording(c);
    },
    seekCall(ev, c) {
      if (this.callRec.id !== c.id) return; // solo la llamada cargada es "buscable"
      const a = this.callRec.audio;
      if (!a || !this.callRec.duration) return;
      const rect = ev.currentTarget.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (ev.clientX - rect.left) / rect.width));
      a.currentTime = ratio * this.callRec.duration;
      this.callRec.current = a.currentTime;
    },
    callProgressPct() {
      return this.callRec.duration > 0 ? Math.min(100, (this.callRec.current / this.callRec.duration) * 100) : 0;
    },
    async downloadCall(c) {
      let url = this.callRec.id === c.id && this.callRec.url ? this.callRec.url : null;
      let temp = false;
      try {
        if (!url) {
          const { data } = await axios.get(`/voice-agent/call-recording/${c.id}`, { responseType: "blob" });
          url = URL.createObjectURL(data);
          temp = true;
        }
        const a = document.createElement("a");
        a.href = url;
        a.download = `llamada-${c.id}.mp3`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        if (temp) setTimeout(() => { try { URL.revokeObjectURL(url); } catch (e) { /* noop */ } }, 2000);
      } catch (e) { /* noop */ }
    },
    fmtCallTime(s) {
      if (!s || !isFinite(s)) return "0:00";
      const m = Math.floor(s / 60);
      const ss = Math.floor(s % 60);
      return m + ":" + (ss < 10 ? "0" : "") + ss;
    },

    handleSystemActionTriggered(payload) {
      this.manualCheckinResolvedAt = payload?.sent_at || new Date().toISOString();
    },

    isContentRenderable(content) {
      return content !== null && content !== undefined && String(content).trim().length > 0;
    },

    /**
     * El Enter del chat de la reserva.
     *
     * Con el traductor encendido y un huésped que habla otro idioma, el primero
     * NO manda: enseña en qué va a llegarle. El segundo ya lo manda traducido.
     */
    alPulsarEnterEnElChat() {
      const loLleva = this.tradAlPulsarEnter(
        this.messageText,
        this.reservationData && this.reservationData.id,
        (traducido) => {
          this.messageText = traducido;
          this.$nextTick(() => this.sendMessage());
        },
      );
      if (!loLleva) this.sendMessage();
    },

    /** Manda lo que se ha previsualizado, desde el botón de la barra. */
    tradEnviarLaPrevia() {
      const previa = this.trad.previa;
      if (!previa) return;
      this.trad.previa = null;
      this.messageText = previa.texto;
      this.$nextTick(() => this.sendMessage());
    },

    formatMessage(content) {
      if (content === null || content === undefined) return "";
      const str = String(content).trim();
      if (!str) return "";

      try {
        return marked(str).replace(/<a /g, '<a target="_blank" ');
      } catch (e) {
        return str
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/\n/g, "<br>");
      }
    },

    formatSystemMessage(content) {
      if (content === null || content === undefined) return "";
      const str = String(content).trim();
      if (!str) return "";

      try {
        return marked(str).replace(/<a /g, '<a target="_blank" ');
      } catch (e) {
        return str.replace(/\n/g, "<br>");
      }
    },

    async fetchConversationStatus(options = {}) {
      const { force = false } = options;
      if (this.activeTab !== "whatsapp" || !this.mostrar) return;
      if (this.loadingConversationStatus && !force) return;

      const rawPhone =
        this.mostrar.phone_number ||
        this.mostrar.senderPhone ||
        this.mostrar.phoneDigits ||
        (this.mostrar.raw && this.mostrar.raw.phone_number) ||
        "";

      const phone = this.normalizePhone(rawPhone);
      if (!phone) return;

      const propertyId =
        this.reservationData?.propiedad_id ||
        this.reservationData?.property_id ||
        this.reservationData?.propiedad?.id;

      const reservationId = this.reservationData?.id;
      const historyLength = Array.isArray(this.mostrar?.chat_history)
        ? this.mostrar.chat_history.length
        : 0;
      const requestKey = [phone, propertyId || "all", reservationId || "no-reservation", historyLength].join("|");
      const now = Date.now();

      if (
        this.lastConversationStatusRequestKey === requestKey &&
        now - Number(this.lastConversationStatusRequestAt || 0) < 1200
      ) {
        return;
      }

      this.lastConversationStatusRequestKey = requestKey;
      this.lastConversationStatusRequestAt = now;

      this.loadingConversationStatus = true;

      try {
        const { data } = await axios.get("/check-conversation-status", {
          params: {
            phone,
            property_id: propertyId,
            reservation_id: reservationId,
          },
        });

        if (data.success) this.conversationStatus = data.data;
      } catch (error) {
        console.error("Error verificando estado de conversación:", error);
        this.conversationStatus = {
          can_send_freeform: true,
          needs_template: false,
          account_ok: true,
          errors: [],
          warnings: [],
        };
      } finally {
        this.loadingConversationStatus = false;
      }
    },

    isMessageFailed(message) {
      if (!message) return false;
      // La ventana de 24 h NO es un fallo. Cuando está cerrada, el mensaje queda EN
      // COLA (un solo check), al huésped le sale la plantilla de re-contacto y, al
      // aceptarla, se le entrega lo que estaba esperando. El sistema lo resuelve solo,
      // así que no hay nada que avisar ni nada que «reactivar»: pintarlo en rojo hacía
      // creer al anfitrión que el mensaje se había perdido.
      const codigoVentana = Number(
        message?.error_code || message?.extra?.error_code || message?.error?.code || 0
      );
      if (message?.can_retry_template || codigoVentana === 131047 || codigoVentana === 470) {
        return false;
      }
      if (String(message?.wa_status || "").toLowerCase() === "queued") return false;

      if (message.status === "failed") return true;
      if (message.failed) return true;
      if (message.wa_status === "failed") return true;
      if (message.extra && message.extra.status === "failed") return true;
      if (message.extra && message.extra.error) return true;
      return false;
    },

    messageKey(message, index = 0) {
      const firstWaId = Array.isArray(message?.wa_message_ids) ? message.wa_message_ids[0] : null;
      const contentSeed = String(message?.content || "").trim().slice(0, 48);

      return (
        message?.__client_key ||
        message?.id ||
        message?.wa_message_id ||
        firstWaId ||
        message?.extra?.message_id ||
        `${message?.role || "msg"}-${message?.timestamp || "no-time"}-${message?.type || "text"}-${contentSeed || "empty"}-${index}`
      );
    },

    shouldShowDeliveryStatus(message) {
      return (
        this.activeTab === "whatsapp" &&
        message?.role === "assistant" &&
        !this.isMessageFailed(message) &&
        (!!message?.wa_status || !!message?.sent_by_agent || (!message?.pending && !message?.sending))
      );
    },

    whatsappStatusLabel(message) {
      const status = String(message?.wa_status || "sent").toLowerCase();
      if (status === "read") return this.$t("reservationConversations.delivery.read");
      if (status === "delivered") return this.$t("reservationConversations.delivery.delivered");
      if (status === "queued") return this.$t("reservationConversations.delivery.queued");
      if (status === "failed") return this.$t("reservationConversations.delivery.failed");
      return this.$t("reservationConversations.delivery.sent");
    },

    whatsappStatusChecks(message) {
      const status = String(message?.wa_status || "sent").toLowerCase();
      // Un solo check hasta la confirmación de lectura real:
      // queued / sent / delivered → "✓"; solo read → "✓✓".
      if (status === "read") return "✓✓";
      if (status === "failed") return "!";
      return "✓";
    },

    whatsappStatusClass(message) {
      const status = String(message?.wa_status || "sent").toLowerCase();
      return `message-delivery-status--${status || "sent"}`;
    },

    getMessageErrorText(message) {
      const raw = String(
        message?.error?.message ||
        message?.error ||
        message?.extra?.error?.message ||
        message?.extra?.error ||
        ""
      ).trim();

      return raw || this.$t("reservationConversations.errors.genericSendFail");
    },

    isInternalSystemMessage(message) {
      if (!message || message.role !== "system") return false;

      const metaType = String(message?.meta?.type || "").trim().toLowerCase();
      if (metaType) return false;

      const content = String(message?.content || "").trim();
      return content.startsWith("Eres el asistente de");
    },

    // Motivo CORTO para el label pequeño de debajo de la burbuja. El texto largo va
    // en el title (al pasar el ratón), para no llenar el chat de rojo.
    messageFailureShort(mensaje) {
      const code = Number(
        mensaje?.error_code || mensaje?.extra?.error_code || mensaje?.error?.code || 0
      );

      const cortos = {
        131042: this.$t("reservationConversations.failureShort.paymentIssue"),
        131026: this.$t("reservationConversations.failureShort.cannotReceive"),
        131053: this.$t("reservationConversations.failureShort.downloadFailed"),
        132000: this.$t("reservationConversations.failureShort.templateMissingData"),
        131009: this.$t("reservationConversations.failureShort.requirementsNotMet"),
      };

      if (cortos[code]) return cortos[code];

      const texto = this.getMessageErrorText(mensaje);
      return texto.length > 90 ? texto.slice(0, 88).trim() + "…" : texto;
    },

    messageFailureTitle(message) {
      const errorText = this.getMessageErrorText(message).toLowerCase();
      if (errorText.includes("no tiene whatsapp") || errorText.includes("no está disponible en whatsapp")) {
        return this.$t("reservationConversations.failureTitle.noWhatsapp");
      }
      if (errorText.includes("no es válido")) {
        return this.$t("reservationConversations.failureTitle.invalidNumber");
      }
      return this.$t("reservationConversations.failureTitle.notSent");
    },

    reactivationHelperText(message) {
      // Se conserva por compatibilidad: ya no hay ninguna vista que hable de la
      // ventana, porque para nosotros no se vence (el mensaje queda en cola).
      return this.getMessageErrorText(message);
    },

    async sendReactivationTemplate() {
      const chatId = this.mostrar?.id || this.mostrar?.chat_id;
      if (!chatId) {
        toastr.error(this.$t("reservationConversations.toast.reactivateNoConv"));
        return;
      }

      try {
        const { data } = await axios.post(`/whatsapp-crm/conversations/${chatId}/reactivate-template`);
        if (Array.isArray(data?.data?.historial)) {
          this.$set(this.mostrar, "chat_history", data.data.historial.map((msg) => ({ ...msg })));
          this.$set(this.mostrar, "__full_history_loaded", true);
        }
        await this.$nextTick();
        this.scrollToBottom(true);
        if (data?.success) {
          toastr.success(data?.message || this.$t("reservationConversations.toast.templateSent"));
        } else {
          toastr.error(data?.message || this.$t("reservationConversations.toast.reactivateFail"));
        }
      } catch (error) {
        toastr.error(
          error?.response?.data?.message ||
            this.$t("reservationConversations.toast.reactivateFail")
        );
      }
    },

    async retryMessage(failedMsg, index) {
      if (this.isSending) return;

      if (index !== undefined && this.mostrar.chat_history[index]) {
        this.mostrar.chat_history.splice(index, 1);
      }

      this.messageText = failedMsg.content || "";
      await this.$nextTick();
      this.sendMessage();
    },

    openConversation(chat) {
      const baseHistory = this.getChatHistory(chat);
      const history = Array.isArray(baseHistory) ? baseHistory.map((m) => ({ ...m })) : [];
      const nextChatKey = this.getChatKey(chat);

      this.mostrar = {
        ...chat,
        chat_history: history,
        __full_history_loaded: false,
      };

      // Solo mostramos la silueta si de verdad hay que ir a buscar el hilo; si ya lo
      // tenemos entero (p. ej. al volver de la lista) se abre directo, sin parpadeo.
      this.conversationLoading = !history.length;

      this.activeChatKey = nextChatKey;
      this.isManualMode = this.esManualDe(chat);
      this.messageText = "";
      this.selectedFiles = [];
      this.selectedPredefinedAttachments = [];
      this.showPredefinedList = false;
      this.filteredQuestions = [];
      this.conversationStatus = null;

      this.$set(this.mostrar, "read", true);
      if (this.mostrar.unread !== undefined) this.$set(this.mostrar, "unread", false);
      if (this.mostrar.unread_count !== undefined) this.$set(this.mostrar, "unread_count", 0);

      this.fetchPredefinedQuestions();
      this.fetchConversationStatus();
      this._refreshMostrar({ chat, expectedChatKey: nextChatKey });

      this.$nextTick(() => {
        this.scrollToBottom(true);
        this.userIsAtBottom = true;
      });
    },

    backToList() {
      this.mostrar = null;
      this.messageText = "";
      this.selectedFiles = [];
      this.selectedPredefinedAttachments = [];
      this.isManualMode = false;
      this.isDragOver = false;
      this.activeChatKey = null;
      this.showPredefinedList = false;
      this.filteredQuestions = [];
      this.conversationStatus = null;
      this.loadingConversationStatus = false;
      this.conversationLoading = false;
    },

    async sendMessage() {
      if (
        (this.activeTab !== "whatsapp" && this.activeTab !== "web") ||
        !this.mostrar ||
        (!this.messageText.trim() && !this.selectedFiles.length && !this.selectedPredefinedAttachments.length)
      ) {
        return;
      }

      if (this.isSending) return;

      const message = this.messageText.trim();
      this.isSending = true;
      const filesToSend = [...this.selectedFiles];
      const predefinedToSend = [...this.selectedPredefinedAttachments];
      const tempMessageId = `temp_${Date.now()}`;

      try {
        const rawPhone =
          this.mostrar.phone_number ||
          this.mostrar.senderPhone ||
          this.mostrar.phoneDigits ||
          (this.mostrar.raw && this.mostrar.raw.phone_number) ||
          "";

        const phone = this.normalizePhone(rawPhone);

        if (!phone && this.activeTab !== "web") {
          // Pasa con reservas cuyo teléfono no es un teléfono (importaciones antiguas
          // guardaron ahí el código de reserva, p. ej. "00012634"). Antes se salía por
          // aquí sin decir nada: el operador escribía, pulsaba enviar y no ocurría nada.
          this.$toast?.add({
            severity: "warn",
            summary: this.$t("reservationConversations.toast.cannotSendWhatsappTitle"),
            detail: rawPhone
              ? this.$t("reservationConversations.toast.invalidPhoneDetail", { phone: rawPhone })
              : this.$t("reservationConversations.toast.noPhoneDetail"),
            life: 6000,
          });
          this.messageText = message; // no perder lo escrito
          return;
        }

        const propertyId = this.reservationData?.propiedad_id || this.reservationData?.property_id;
        const checkinId = this.mostrar.checkinId || this.mostrar.checkin_id || this.mostrar.raw?.checkinId || null;

        const newMessage = {
          id: tempMessageId,
          role: "assistant",
          content: message,
          timestamp: new Date().toISOString(),
          sending: true,
        };

        if (this.mostrar.chat_history) {
          this.mostrar.chat_history.push(newMessage);
        } else {
          this.$set(this.mostrar, "chat_history", [newMessage]);
        }

        this.messageText = "";
        this.selectedFiles = [];
        this.selectedPredefinedAttachments = [];

        if (this.$refs.fileInput) this.$refs.fileInput.value = "";

        this.$nextTick(() => {
          this.userIsAtBottom = true;
          this.scrollToBottom(false);
        });

        const formData = new FormData();
        formData.append("phone", phone);
        formData.append("property_id", propertyId);

        if (checkinId) formData.append("checkin_id", checkinId);
        if (this.reservationData?.id) formData.append("reservation_id", this.reservationData.id);
        if (message) formData.append("message", message);

        if (filesToSend.length) {
          filesToSend.forEach((file) => formData.append("attachments[]", file));
        }

        if (predefinedToSend.length) {
          const payloadPredef = predefinedToSend.map((att) => ({
            type: att.type || this.inferAttachmentType(att.url),
            url: att.url,
            name: att.name || this.getFileNameFromUrl(att.url) || this.$t("reservationConversations.composer.fileFallback"),
          }));
          formData.append("predefined_attachments", JSON.stringify(payloadPredef));
        }

        let sendUrl = "/send-manual-message";
        if (this.activeTab === "web") {
          sendUrl = this.mostrar.__webNew
            ? `/whatsapp-crm/reservations/${this.reservationData.id}/web-start`
            : `/whatsapp-crm/conversations/${this.mostrar.id}/send`;
        }
        const { data } = await axios.post(sendUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // Tras INICIAR el chat web, fijamos la conversación real creada.
        if (this.activeTab === "web" && data?.data?.conversation_id) {
          this.$set(this.mostrar, "id", data.data.conversation_id);
          this.$set(this.mostrar, "chat_id", data.data.conversation_id);
          this.mostrar.__webNew = false;
          this.activeChatKey = this.getChatKey(this.mostrar);
        }

        const serverHistory = data?.data?.chat?.historial || data?.data?.historial;
        if (Array.isArray(serverHistory)) {
          this.$set(this.mostrar, "chat_history", serverHistory.map((m) => ({ ...m })));
          this.$set(this.mostrar, "__full_history_loaded", true);
          this.$nextTick(() => this.scrollToBottom(false));
        }

        if (!data.success) {
          this.$toast?.add({
            severity: "error",
            summary: this.$t("reservationConversations.toast.sendErrorTitle"),
            detail: data.message || this.$t("reservationConversations.toast.sendErrorDetail"),
            life: 5000,
          });
        } else if (!Array.isArray(serverHistory)) {
          const cleanedHistory = Array.isArray(this.mostrar?.chat_history)
            ? this.mostrar.chat_history.filter((msg) => msg?.id !== tempMessageId)
            : [];
          this.$set(this.mostrar, "chat_history", cleanedHistory);
        }
      } catch (error) {
        console.error("Error enviando mensaje:", error);
        const cleanedHistory = Array.isArray(this.mostrar?.chat_history)
          ? this.mostrar.chat_history.filter((msg) => msg?.id !== tempMessageId)
          : [];
        this.$set(this.mostrar, "chat_history", cleanedHistory);
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservationConversations.toast.errorTitle"),
          detail: this.$t("reservationConversations.toast.sendErrorDetail"),
          life: 3000,
        });
      } finally {
        this.isSending = false;
      }
    },

    getChatHistory(chat) {
      if (!chat) return [];
      return chat.messages || chat.chat_history || chat.historial || chat.conversation || [];
    },

    normalizePhone(raw) {
      if (raw === null || raw === undefined) return null;
      let s = String(raw);
      s = s.replace(/[\s\-\(\)\.]/g, "");
      s = s.replace(/[^0-9+]/g, "");
      s = s.replace(/^00/, "+");
      s = s.replace(/^\++/, "+");
      s = s.replace(/(?!^)\+/g, "");
      if (s !== "" && s[0] !== "+") s = `+${s}`;
      const digits = s.replace(/\D/g, "");
      if (digits.length < 7) return null;
      return s;
    },

    onlyDigits(phone) {
      return String(phone || "").replace(/\D/g, "");
    },

    getChatKey(chat) {
      if (!chat) return null;
      const canonicalChatId = chat.chat_id || chat.id || null;
      if (canonicalChatId) return `chat_${canonicalChatId}`;
      if (chat.uuid) return `uuid_${chat.uuid}`;

      const phone = this.onlyDigits(chat.phone_number || chat.senderPhone || chat.phoneDigits || "");
      const checkinId = chat.checkin_id || chat.checkinId || "";

      if (phone || checkinId) return `ph_${phone}_ck_${checkinId}`;
      return null;
    },

    // La bandeja de mensajes del nav abre esta reserva pidiendo un canal concreto
    // (`initialTab`) y, cuando lo conoce, la conversación exacta (`initialChatId`).
    // Se llama desde created() y desde los watchers porque reservationData y las
    // listas de chats llegan asíncronas; se aplica una sola vez.
    /**
     * En una reserva de Booking la pestaña que se abre es la suya, no WhatsApp.
     *
     * Se aplica UNA sola vez y solo si nadie pidió otra cosa: si quien abre el cajón
     * mandó una pestaña concreta (`initialTab`), esa manda; y en cuanto el anfitrión
     * cambia de pestaña a mano, no se le vuelve a mover.
     */
    /**
     * ¿Hay pestañas fuera de la vista? Enciende o apaga las flechas.
     *
     * Se llama al desplazar, al cambiar el tamaño y cuando cambia el juego de
     * pestañas (una reserva con llamadas tiene una más que otra sin ellas).
     */
    medirCarril() {
      const el = this.$refs.carrilPestanas;
      if (!el) {
        this.puedeIzquierda = this.puedeDerecha = false;
        return;
      }
      // 2px de margen: en pantallas con escalado los decimales del navegador dejaban
      // la flecha encendida sobre un carril que ya estaba al final.
      const resto = el.scrollWidth - el.clientWidth - el.scrollLeft;
      this.puedeIzquierda = el.scrollLeft > 2;
      this.puedeDerecha = resto > 2;
    },

    /** Avanza o retrocede casi una pantalla, dejando una pestaña de solape como pista. */
    desplazarPestanas(sentido) {
      const el = this.$refs.carrilPestanas;
      if (!el) return;
      el.scrollBy({ left: sentido * Math.max(160, el.clientWidth * 0.72), behavior: "smooth" });
    },

    /** Que la pestaña elegida nunca se quede escondida fuera del carril. */
    asomarPestanaActiva() {
      this.$nextTick(() => {
        const el = this.$refs.carrilPestanas;
        const activa = el && el.querySelector(".rm-tab.active");
        if (activa && activa.scrollIntoView) {
          activa.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
        }
        this.medirCarril();
      });
    },

    aplicarPestanaPorCanal() {
      if (this.pestanaPorCanalHecha || this.initialTab) return;
      if (!this.reservationData || !this.otaPrimero) return;

      this.pestanaPorCanalHecha = true;
      if (this.activeTab === "whatsapp") this.switchTab("otas");
    },

    applyInitialTarget() {
      if (this.initialTargetDone || !this.initialTab) return;

      const tab = String(this.initialTab).toLowerCase();
      if (!["whatsapp", "web", "otas"].includes(tab)) {
        this.initialTargetDone = true;
        return;
      }

      // La pestaña de OTA solo existe si la reserva viene de Booking/Airbnb, y eso
      // sale de reservationData (que puede no haber llegado todavía).
      if (tab === "otas") {
        if (!this.reservationData) return;
        if (!this.showOtaTab) {
          this.initialTargetDone = true;
          return;
        }
      }

      if (this.activeTab !== tab) this.switchTab(tab);

      if (tab === "whatsapp" && this.initialChatId) {
        const target = (this.whatsappChats || []).find(
          (chat) =>
            String(chat?.id ?? chat?.chat_id ?? "") === String(this.initialChatId)
        );
        if (!target) return; // aún no ha llegado la lista: se reintenta
        this.openConversation(target);
      }

      if (tab === "web") {
        // switchTab ya dejó un placeholder si aún no hay hilo; al llegar el real
        // lo abrimos para no dejar al operador escribiendo sobre el placeholder.
        if (!(this.webChats || []).length) return;
        this.openConversation(this.webChats[0]);
      }

      this.initialTargetDone = true;
    },

    switchTab(tab) {
      if (this.activeTab === tab) return;
      if (tab === "otas" && !this.showOtaTab) return;
      if (tab === "llamadas" && !this.showCallsTab) return;
      if (tab === "checkin" && !this.showCheckinTab) return;
      if (tab === "charges" && !this.showChargesTab) return;
      if (tab === "note" && !this.showNotesTab) return;

      this.activeTab = tab;
      // Si la elegida estaba fuera del carril, que se vea.
      this.asomarPestanaActiva();
      this.searchQuery = "";

      if (tab === "whatsapp" || tab === "otas" || tab === "web") {
        this.backToList();
      }

      if (tab === "web") {
        this.$nextTick(() => this.setupWebConversation());
      }
    },

    // Canal web: hay una conversación por reserva. Si existe la abrimos; si no,
    // preparamos un placeholder para que el host pueda INICIAR el chat.
    setupWebConversation() {
      if ((this.webChats || []).length) {
        this.openConversation(this.webChats[0]);
        return;
      }
      // El canal web nace en IA si el Agente está activo para el anuncio (para que
      // responda los mensajes del huésped); solo pasa a manual si el host interviene.
      const agentActive = !!this.reservationData?.web_agent_active;
      this.mostrar = {
        __webNew: true,
        channel: "web",
        is_active: agentActive,
        reserva_id: this.reservationData?.id,
        property_id: this.reservationData?.propiedad_id || this.reservationData?.property_id,
        display_name: this.reservationData?.nombre || this.$t("reservationConversations.webGuestFallback"),
        chat_history: [],
        __full_history_loaded: true,
      };
      this.activeChatKey = "web-new";
      this.isManualMode = !agentActive;
      this.messageText = "";
      this.selectedFiles = [];
      this.selectedPredefinedAttachments = [];
      this.conversationStatus = null;
    },

    async fetchPredefinedQuestions() {
      try {
        const listingId = this.$store.state.property?.property?.listing_id;
        if (!listingId) return;
        const { data } = await axios.get(`/retrive/waba/${listingId}/bot-config-question`);
        this.predefinedQuestions = data.map((question) => ({
          ...question,
          img: question.image?.image || null,
        }));
      } catch (error) {
        console.error("Error al cargar preguntas predefinidas:", error);
      }
    },

    handlePredefinedQuestionsVisibility(text) {
      if (!text.startsWith("/")) {
        this.showPredefinedList = false;
        this.filteredQuestions = [];
        return;
      }

      const searchText = text.slice(1).toLowerCase();

      if (searchText === "") {
        this.filteredQuestions = this.predefinedQuestions;
        this.showPredefinedList = true;
      } else {
        this.filteredQuestions = this.predefinedQuestions.filter((question) =>
          question.question.toLowerCase().includes(searchText)
        );
        this.showPredefinedList = this.filteredQuestions.length > 0;
      }
    },

    selectPredefinedQuestion(question) {
      this.messageText = question.answer || "";
      this.showPredefinedList = false;
      this.filteredQuestions = [];
      this.selectedPredefinedAttachments = [];
      this.$nextTick(() => this.$refs.messageInput?.focus());
    },

    handleClickOutside(event) {
      const dropdown = this.$refs.predefinedDropdown;
      const input = this.$refs.messageInput;

      if (dropdown && !dropdown.contains(event.target) && input && !input.contains(event.target)) {
        this.showPredefinedList = false;
      }
    },

    getGuestFullName(obj) {
      if (!obj) return this.$t("reservationConversations.guestFallback");

      const fullName = obj.guest_full_name || "";
      if (fullName) return fullName;

      const name =
        obj.guest_name ||
        obj.nombre ||
        obj.senderName ||
        (obj.raw && obj.raw.nombre) ||
        this.$t("reservationConversations.guestFallback");

      const lastname = obj.apellido || (obj.raw && obj.raw.apellido) || "";
      return lastname ? `${name} ${lastname}` : name;
    },

    // Teléfono del chat (para mostrarlo junto al nombre en la lista y saber de
    // qué conversación se trata, sobre todo en reservas combinadas de varias filas).
    getChatPhone(chat) {
      if (!chat) return "";
      const raw =
        chat.phone_number ||
        chat.senderPhone ||
        chat.phoneDigits ||
        (chat.raw && chat.raw.phone_number) ||
        "";
      const s = String(raw).trim();
      if (!s) return "";
      return s.startsWith("+") ? s : "+" + s.replace(/\D/g, "");
    },

    getInitials(name) {
      const safe = String(name || "").trim();
      if (!safe) return "G";
      const parts = safe.split(/\s+/).filter(Boolean);
      if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
      return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
    },

    isChatUnread(chat) {
      if (chat.read === false) return true;
      if (chat.unread === true) return true;
      if (typeof chat.unread_count === "number" && chat.unread_count > 0) return true;
      if (chat.has_new_message === true) return true;
      return false;
    },

    prettyTime(ts) {
      if (!ts) return "";
      const d = ts instanceof Date ? ts : new Date(ts);
      const now = new Date();
      const isToday = d.toDateString() === now.toDateString();
      const yest = new Date(now);
      yest.setDate(now.getDate() - 1);
      const isYesterday = d.toDateString() === yest.toDateString();

      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");

      if (isToday) return this.$t("reservationConversations.time.today", { time: `${hh}:${mm}` });
      if (isYesterday) return this.$t("reservationConversations.time.yesterday", { time: `${hh}:${mm}` });
      return `${d.toLocaleDateString()} ${hh}:${mm}`;
    },

    truncateMessage(message, length = 110) {
      if (!message) return "";
      return message.length <= length ? message : `${message.substring(0, length)}…`;
    },

    handleScroll() {
      const el = this.$refs.chatContainer;
      if (!el) return;
      const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      this.userIsAtBottom = scrollBottom < 50;
    },

    scrollToBottom(smooth = false) {
      const el = this.$refs.chatContainer;
      if (!el) return;

      if (smooth) {
        el.style.scrollBehavior = "smooth";
        requestAnimationFrame(() => {
          el.scrollTop = el.scrollHeight;
          setTimeout(() => {
            el.style.scrollBehavior = "auto";
          }, 400);
        });
      } else {
        const prev = el.style.scrollBehavior;
        el.style.scrollBehavior = "auto";
        el.scrollTop = el.scrollHeight;
        if (prev && prev !== "auto") el.style.scrollBehavior = prev;
      }
    },

    _attachmentSignature(message = {}) {
      const attachments = Array.isArray(message?.attachments)
        ? message.attachments
        : message?.attachment
          ? [message.attachment]
          : [];

      return attachments
        .map((attachment) => {
          if (!attachment || typeof attachment !== "object") return "";
          return (
            attachment.url ||
            attachment.path ||
            attachment.name ||
            attachment.id ||
            ""
          );
        })
        .filter(Boolean)
        .join("|");
    },

    _historyMessageKey(message = {}, fallbackIndex = null) {
      const firstWaId = Array.isArray(message?.wa_message_ids)
        ? message.wa_message_ids[0]
        : null;
      const contentSeed = String(message?.content || "").trim().slice(0, 72);
      const timestamp = message?.timestamp || "no-time";
      const role = message?.role || "msg";
      const type = message?.type || "text";
      const attachmentSeed = this._attachmentSignature(message) || "no-attachment";
      const sourceSeed =
        message?.extra?.message_id ||
        message?.extra?.source ||
        message?.extra?.whatsapp_media_id ||
        "no-source";

      return (
        message?.__client_key ||
        message?.id ||
        message?.wa_message_id ||
        firstWaId ||
        `${role}|${timestamp}|${type}|${contentSeed || "empty"}|${attachmentSeed}|${sourceSeed}`
      );
    },

    _messageTimestampMs(message = {}) {
      const value = message?.timestamp;
      if (!value) return 0;
      const ms = new Date(value).getTime();
      return Number.isFinite(ms) ? ms : 0;
    },

    _dedupeHistory(history = []) {
      if (!Array.isArray(history) || !history.length) return [];

      const deduped = [];
      const seen = new Set();

      history.forEach((message, index) => {
        const key = this._historyMessageKey(message, index);
        if (seen.has(key)) return;
        seen.add(key);
        deduped.push(message);
      });

      return deduped;
    },

    // ── Merge de historiales: nunca baja el rango de estado de un mensaje ───
    // Orden de estados (mayor = más avanzado):  read > delivered > sent > failed
    // Cuando retrieveGlobalChats devuelve datos ligeramente más viejos que el
    // socket, este helper preserva el estado más alto ya almacenado localmente.
    _mergeHistories(incoming, current) {
      const STATUS_RANK = { read: 3, delivered: 2, sent: 1, failed: 0 };

      if (!Array.isArray(current) || !current.length) {
        return this._dedupeHistory(Array.isArray(incoming) ? incoming : []);
      }

      const incomingItems = Array.isArray(incoming) ? incoming : [];
      if (!incomingItems.length) return current;

      const currentMap = {};
      current.forEach((message, index) => {
        currentMap[this._historyMessageKey(message, index)] = message;
      });

      const matchedKeys = new Set();

      const merged = incomingItems.map((msg, index) => {
        const key = this._historyMessageKey(msg, index);
        const existing = currentMap[key];

        if (!existing) return msg;

        matchedKeys.add(key);

        const mergedMessage = { ...existing, ...msg };
        const incomingRank = STATUS_RANK[String(msg?.wa_status || "").toLowerCase()] ?? -1;
        const existingRank = STATUS_RANK[String(existing?.wa_status || "").toLowerCase()] ?? -1;

        if (!msg?.wa_message_id && existing?.wa_message_id) {
          mergedMessage.wa_message_id = existing.wa_message_id;
        }

        if (
          (!Array.isArray(msg?.wa_message_ids) || !msg.wa_message_ids.length) &&
          Array.isArray(existing?.wa_message_ids) &&
          existing.wa_message_ids.length
        ) {
          mergedMessage.wa_message_ids = existing.wa_message_ids;
        }

        if (!msg?.wa_status || existingRank > incomingRank) {
          mergedMessage.wa_status = existing?.wa_status || msg?.wa_status || null;
          mergedMessage.wa_status_updated_at =
            existing?.wa_status_updated_at || msg?.wa_status_updated_at || null;
        }

        if (!msg?.sent_by_agent && existing?.sent_by_agent) {
          mergedMessage.sent_by_agent = true;
        }

        if (
          (!Array.isArray(msg?.attachments) || !msg.attachments.length) &&
          Array.isArray(existing?.attachments) &&
          existing.attachments.length
        ) {
          mergedMessage.attachments = existing.attachments;
        }

        if (!msg?.attachment && existing?.attachment) {
          mergedMessage.attachment = existing.attachment;
        }

        if ((msg?.pending === undefined || msg?.pending === null) && existing?.pending !== undefined) {
          mergedMessage.pending = existing.pending;
        }

        if (!this.isMessageFailed(msg) && this.isMessageFailed(existing)) {
          mergedMessage.failed = true;
          mergedMessage.error = existing?.error ?? mergedMessage.error;
          mergedMessage.error_code = existing?.error_code ?? mergedMessage.error_code;
          mergedMessage.error_title = existing?.error_title ?? mergedMessage.error_title;
          mergedMessage.can_retry_template =
            existing?.can_retry_template ?? mergedMessage.can_retry_template;
          mergedMessage.retry_template_name =
            existing?.retry_template_name ?? mergedMessage.retry_template_name;
          mergedMessage.wa_status = existing?.wa_status || mergedMessage.wa_status || "failed";
          mergedMessage.wa_status_updated_at =
            existing?.wa_status_updated_at || mergedMessage.wa_status_updated_at || null;
        }

        return mergedMessage;
      });

      current.forEach((message, index) => {
        const key = this._historyMessageKey(message, index);
        if (matchedKeys.has(key)) return;

        const shouldPreserve =
          message?.sending ||
          message?.pending ||
          this.isMessageFailed(message) ||
          Date.now() - this._messageTimestampMs(message) < 180000;

        if (shouldPreserve) {
          // Red de seguridad contra duplicados por key-mismatch:
          // Un mismo mensaje puede tener dos keys distintas si una versión
          // llega del socket (sin wa_message_id, key por contenido) y otra
          // del API (con wa_message_id, key = wamid). Antes de hacer push,
          // verificamos que no haya ya en merged un mensaje con el mismo
          // role + timestamp + contenido (primeros 72 chars).
          const msgRole      = message?.role || "";
          const msgTimestamp = message?.timestamp || "";
          const msgContent   = String(message?.content || "").trim().slice(0, 72);

          const alreadyPresent = merged.some((m) => {
            if ((m?.role || "") !== msgRole) return false;
            if ((m?.timestamp || "") !== msgTimestamp) return false;
            return String(m?.content || "").trim().slice(0, 72) === msgContent;
          });

          if (!alreadyPresent) {
            merged.push({ ...message });
          }
        }
      });

      return this._dedupeHistory(
        merged.sort((a, b) => this._messageTimestampMs(a) - this._messageTimestampMs(b))
      );
    },

    // ── Manejador del socket global (App.vue → $root → aquí) ────────────────
    async copyStayPortalLink() {
      const link = this.stayPortalLink;
      if (!link) return;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(link);
        } else {
          const ta = document.createElement("textarea");
          ta.value = link;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.copiedPortalLink = true;
        setTimeout(() => { this.copiedPortalLink = false; }, 1800);
      } catch (e) {
        this.$toast?.add({ severity: "error", summary: this.$t("reservationConversations.toast.errorTitle"), detail: this.$t("reservationConversations.toast.copyLinkFail"), life: 2500 });
      }
    },

    _onCrmSocketPayload(event = {}) {
      const payload = event?.payload || {};
      const payloadChatId = Number(payload?.chat_id || 0);
      const currentChatId = Number(this.mostrar?.id || this.mostrar?.chat_id || 0);

      console.log("[CRM-RT][ResConv] _onCrmSocketPayload", {
        source: event?.source || null,
        activeTab: this.activeTab,
        hasMostrar: !!this.mostrar,
        payloadChatId,
        currentChatId,
        payloadChannel: payload?.channel || null,
        hasConversation: Array.isArray(payload?.conversation),
      });

      if (!this.mostrar) return;

      // Si el payload tiene chat_id y NO coincide con la conversación activa, ignorar
      if (payloadChatId && currentChatId && payloadChatId !== currentChatId) {
        console.log("[CRM-RT][ResConv] ignorado: chat_id no coincide");
        return;
      }

      // Si el payload trae la conversación directamente (historial), usarla
      let historial = payload?.conversation || payload?.historial;
      if (typeof historial === "string") {
        try { historial = JSON.parse(historial); } catch (_) { historial = null; }
      }

      if (Array.isArray(historial) && historial.length) {
        const merged = this._mergeHistories(
          historial.map((m) => ({ ...m })),
          this.mostrar.chat_history || []
        );
        this.$set(this.mostrar, "chat_history", merged);
        this.$nextTick(() => {
          if (this.userIsAtBottom) this.scrollToBottom(false);
        });
        return;
      }

      // Fallback: recargar la conversación desde el API
      this._refreshMostrar();
    },

    async _refreshMostrar(options = {}) {
      const { chat = null, expectedChatKey = null } = options;
      const chatId = chat?.id || chat?.chat_id || this.mostrar?.id || this.mostrar?.chat_id;
      if (!chatId || this.isSending) {
        // Sin nada que pedir: retiramos la silueta para no dejarla colgada.
        this.conversationLoading = false;
        return;
      }

      const requestId = ++this.activeConversationRequestId;
      const targetChatKey = expectedChatKey || this.getChatKey(chat) || this.activeChatKey;

      try {
        const { data } = await axios.get(`/whatsapp-crm/conversations/${chatId}`);
        const conv = data?.data;
        if (!conv) return;

        if (requestId !== this.activeConversationRequestId) return;
        if (targetChatKey && targetChatKey !== this.activeChatKey) return;

        const history = this.getChatHistory(conv);
        this.mostrar = {
          ...(this.mostrar || {}),
          ...conv,
          chat_id: conv.chat_id || this.mostrar?.chat_id || conv.id || chatId,
          chat_history: Array.isArray(history)
            ? this._dedupeHistory(history.map((m) => ({ ...m })))
            : this.mostrar?.chat_history || [],
          __full_history_loaded: true,
        };
        this.isManualMode = this.esManualDe(this.mostrar);

        if (Array.isArray(history) && history.length) {
          await this.$nextTick();
          if (this.userIsAtBottom) this.scrollToBottom(false);
        }
      } catch (_) {
        // fallo silencioso — no interrumpir la experiencia del usuario
      } finally {
        // Solo la petición vigente puede retirar la silueta: si el operador cambió de
        // chat mientras esta viajaba, la nueva manda.
        if (requestId === this.activeConversationRequestId) {
          this.conversationLoading = false;
        }
      }
    },

    /**
     * ¿Esta conversación se atiende a mano?
     *
     * Con el Agente IA apagado en la propiedad da igual lo que diga el
     * interruptor de la conversación: no va a contestar nadie. Antes se miraba
     * solo `is_active` y el anfitrión veía «respondiendo automáticamente», sin
     * cuadro para escribir y con el interruptor bloqueado: no podía contestar a
     * su huésped por ningún lado.
     */
    esManualDe(chat) {
      const c = chat || {};
      if (c.automation_allowed === false) return true;
      return !c.is_active;
    },

    // ── Toggle IA ↔ Manual ───────────────────────────────────────────────────
    // NOTA: v-model="isManualMode" ya actualiza isManualMode ANTES de que @change
    // dispare. Por eso NO usamos el parámetro `value` (que llega como DOM Event
    // {isTrusted: true} en algunas versiones de PrimeVue), sino this.isManualMode.
    async handleModeChange() {
      if ((this.activeTab !== "whatsapp" && this.activeTab !== "web") || !this.mostrar) return;

      // Leer el nuevo valor del v-model (ya actualizado)
      const value = this.isManualMode;          // true = Manual, false = Agente IA
      const previousMode = !value;              // para revertir si falla

      // Guard: si el Agente IA no está activo para la propiedad, no se puede pasar a IA.
      if (this.agentNotConfigured && value === false) {
        this.isManualMode = true; // forzar manual
        this.$toast?.add({
          severity: "warn",
          summary: this.$t("reservationConversations.toast.agentInactiveTitle"),
          detail: this.$t("reservationConversations.toast.agentInactiveDetail"),
          life: 4000,
        });
        return;
      }

      // El chat del Conserje aún no existe en BD (placeholder): el modo se decide
      // al crearlo con el primer mensaje, así que aquí basta el estado local.
      if (this.mostrar.__webNew) {
        this.$set(this.mostrar, "is_active", !value);
        return;
      }

      const chatId = this.mostrar.id || this.mostrar.chat_id || null;
      if (!chatId) {
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservationConversations.toast.errorTitle"),
          detail: this.$t("reservationConversations.toast.noConvId"),
          life: 3000,
        });
        this.isManualMode = previousMode;
        return;
      }

      this.isChangingMode = true;

      try {
        // Identificamos la conversación por su ID, NO por teléfono+propiedad+reserva:
        // hay chats cuyo property_id quedó desalineado respecto a la reserva (la
        // reserva se movió de propiedad al editarla) y el endpoint viejo respondía 404
        // → el switch volvía solo a "Agente IA" y el operador no podía responder.
        const { data } = await axios.post(
          `/whatsapp-crm/conversations/${chatId}/automation`,
          { enabled: !value } // enabled = agente IA activo = inverso de manual
        );

        const isActive = !!data?.data?.is_active;
        this.$set(this.mostrar, "is_active", isActive);
        this.isManualMode = !isActive;
        this.conversationStatus = null;
        await this.fetchConversationStatus({ force: true });
      } catch (error) {
        console.error("Error cambiando modo:", error);
        // 422 = el backend no permite activar la IA en esta conversación (agente
        // apagado para el anuncio). Se explica en vez de fallar en silencio.
        const detail =
          error?.response?.data?.message || this.$t("reservationConversations.toast.modeChangeFail");
        this.$toast?.add({
          severity: error?.response?.status === 422 ? "warn" : "error",
          summary: error?.response?.status === 422 ? this.$t("reservationConversations.toast.agentUnavailableTitle") : this.$t("reservationConversations.toast.errorTitle"),
          detail,
          life: 4000,
        });
        this.$nextTick(() => {
          this.isManualMode = previousMode; // revertir al estado anterior
        });
      } finally {
        this.isChangingMode = false;
      }
    },

    formatTimestamp(ts) {
      if (!ts) return "";
      return moment(ts).format("DD/MM HH:mm");
    },

    waLink() {
      if (!this.mostrar) return "#";
      const rawPhone =
        this.mostrar.phone_number ||
        this.mostrar.senderPhone ||
        this.mostrar.phoneDigits ||
        (this.mostrar.raw && this.mostrar.raw.phone_number) ||
        "";

      const digits = this.onlyDigits(rawPhone);
      if (!digits) return "#";
      return `https://wa.me/${digits}`;
    },

    triggerFileSelect() {
      this.$refs.fileInput?.click();
    },

    addFiles(files) {
      const MAX_SIZE = 5 * 1024 * 1024;
      const acceptedTypes = ["image/", "application/pdf"];
      const newFiles = [];

      Array.from(files).forEach((file) => {
        const validType =
          acceptedTypes.some((t) => (t.endsWith("/") ? file.type.startsWith(t) : file.type === t)) ||
          file.type.startsWith("image/");

        if (!validType || file.size > MAX_SIZE) return;
        newFiles.push(file);
      });

      if (newFiles.length) {
        this.selectedFiles = [...this.selectedFiles, ...newFiles];
      }

      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },

    onFilesSelected(event) {
      const files = event.target.files || [];
      if (!files.length) return;
      this.addFiles(files);
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    truncateFileName(name, maxLength) {
      if (!name) return "";
      if (name.length <= maxLength) return name;

      const parts = name.split(".");
      const ext = parts.length > 1 ? parts.pop() : "";
      const nameWithoutExt = parts.join(".");
      const truncated = nameWithoutExt.substring(0, maxLength - (ext ? ext.length + 4 : 3));

      return ext ? `${truncated}...${ext}` : `${truncated}...`;
    },

    onDragOver() {
      this.isDragOver = true;
    },

    onDragEnter() {
      this.isDragOver = true;
    },

    onDragLeave(e) {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        this.isDragOver = false;
      }
    },

    onDrop(e) {
      this.isDragOver = false;
      const files = e.dataTransfer?.files || [];
      if (!files.length) return;
      this.addFiles(files);
    },

    inferAttachmentType(url) {
      if (!url) return "document";
      const path = url.split("?")[0].split("#")[0];
      const ext = path.split(".").pop()?.toLowerCase() || "";
      return ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(ext) ? "image" : "document";
    },

    getFileNameFromUrl(url) {
      if (!url) return "";
      try {
        const path = url.split("?")[0].split("#")[0];
        const segments = path.split("/");
        return segments.pop() || "";
      } catch {
        return "";
      }
    },


    // ── Fotos que el Agente IA le manda al huésped ──────────────────────
    // El agente las guarda en `media: [{type, url}]`, hasta cuatro por mensaje.
    // Ni `getMediaUrl` ni `messageHasMedia` miraban ahí, así que la burbuja
    // decía «aquí están las fotos» y no se veía ninguna.
    //
    // Esto NO sustituye a `extra` / `attachments` / `attachment`, que son los
    // adjuntos manuales del anfitrión y los que sube el huésped: se SUMA. Y
    // pinta TODAS, no solo la primera, que es lo que sabía hacer `getMediaUrl`.
    galeriaMedia(msg) {
      const lista = msg && Array.isArray(msg.media) ? msg.media : [];
      if (!lista.length) return [];

      const vistas = [];
      const salida = [];
      lista.forEach((it) => {
        const url = this.resolverMediaUrl(it && (it.url || it.link));
        if (!url) return;
        // Una que no cargue se oculta: mejor nada que un icono roto.
        if (this.mediaFallidas.indexOf(url) !== -1) return;
        // Y si el mismo fichero viniera repetido, una sola vez.
        if (vistas.indexOf(url) !== -1) return;
        vistas.push(url);
        salida.push({
          url,
          tipo: String((it && it.type) || "").toLowerCase() === "video" ? "video" : "image",
        });
      });
      return salida;
    },

    // Las URL del agente son absolutas; si algún día llegara una ruta relativa
    // se completa con el host del backend en vez de quedarse en nada.
    resolverMediaUrl(valor) {
      const bruta = String(valor || "").trim();
      if (!bruta) return "";
      if (/^(https?:|blob:|data:)/.test(bruta)) return bruta;
      const base = process.env.VUE_APP_API_SERVER_BACKEND || "";
      return `${base}/${bruta.replace(/^\/+/, "")}`;
    },

    marcarMediaFallida(url) {
      if (url && this.mediaFallidas.indexOf(url) === -1) this.mediaFallidas.push(url);
    },

    // Una foto sola manda y se ve grande; tres quedan mejor con la primera
    // ocupando el ancho; el resto van en rejilla de dos.
    claseGaleria(msg) {
      const n = this.galeriaMedia(msg).length;
      if (n === 1) return "gallery--one";
      if (n === 3) return "gallery--three";
      return "gallery--grid";
    },

    getMediaUrl(msg) {
      // Ojo: el mensaje puede traer `extra` (objeto) SIN url (p. ej. los adjuntos
      // manuales guardan la dirección en `attachments[0].url`). Por eso solo
      // devolvemos desde `extra` si realmente hay una URL; si no, caemos al
      // fallback de attachments para no dejar el <img> sin src.
      if (msg && msg.extra) {
        const fromExtra =
          msg.extra.url || msg.extra.image_url || msg.extra.audio_url || msg.extra.video_url;
        if (fromExtra) return fromExtra;
      }
      if (msg && msg.attachments && msg.attachments.length) return msg.attachments[0].url || null;
      if (msg && msg.attachment && msg.attachment.url) return msg.attachment.url;
      return null;
    },

    isImageMessage(msg) {
      if (!msg) return false;
      return msg.type === "image";
    },

    isAudioMessage(msg) {
      if (!msg) return false;
      return msg.type === "audio";
    },

    isVideoMessage(msg) {
      if (!msg) return false;
      return msg.type === "video";
    },

    isDocumentMessage(msg) {
      if (!msg) return false;
      return msg.type === "document";
    },

    isLocationMessage(msg) {
      if (!msg) return false;
      return msg.type === "location";
    },

    // ¿La burbuja lleva media/adjuntos? (si no, la hora va en línea estilo WhatsApp)
    messageHasMedia(msg) {
      if (!msg) return false;
      if (
        this.isImageMessage(msg) ||
        this.isAudioMessage(msg) ||
        this.isVideoMessage(msg) ||
        this.isDocumentMessage(msg) ||
        this.isLocationMessage(msg)
      ) {
        return true;
      }
      if (Array.isArray(msg.attachments) && msg.attachments.length) return true;
      if (msg.attachment && (msg.attachment.url || msg.attachment.link)) return true;
      // Las fotos del Agente IA viven en `media`, que esto no miraba.
      if (this.galeriaMedia(msg).length) return true;
      return false;
    },

    getDocumentName(msg) {
      if (!msg) return this.$t("reservationConversations.documentFallback");
      if (msg.extra) {
        return msg.extra.filename || msg.extra.name || this.getFileNameFromUrl(msg.extra.url) || this.$t("reservationConversations.documentFallback");
      }
      return this.$t("reservationConversations.documentFallback");
    },

    getLocationUrl(msg) {
      if (!this.isLocationMessage(msg)) return "#";
      const extra = msg.extra || {};
      if (extra.maps_url) return extra.maps_url;
      if (extra.latitude && extra.longitude) {
        return `https://www.google.com/maps?q=${extra.latitude},${extra.longitude}`;
      }
      return "#";
    },

    formatLocationSubtitle(msg) {
      if (!msg || !msg.extra) return this.$t("reservationConversations.location.openInMaps");
      const extra = msg.extra;
      if (extra.address) return extra.address;
      if (extra.latitude && extra.longitude) {
        return this.$t("reservationConversations.location.viewCoords", { lat: extra.latitude, lng: extra.longitude });
      }
      return this.$t("reservationConversations.location.openInMaps");
    },

    async markAllAsRead() {
      if (!this.hasUnreadNotifications) return;

      const chats = this.currentChats || [];
      const ids = chats
        .map((c) => c.id || c.chat_id || c.uuid || c.checkin_id || c.reservation_code)
        .filter(Boolean);

      try {
        if (ids.length) {
          await axios.post("/bot/notifications/mark-all-read", {
            channel: this.activeTab,
            ids,
          });
        }
      } catch (error) {
        console.error("Error marcando como leídas:", error);
      }
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600;700;800&family=Inter:wght@400;500;600;700;800&display=swap");

.rm-tab {
  .icon-ota {
    margin-left: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
/* ---- Pestaña "Llamadas" (grabaciones del Agente IA de Voz) ---- */
.rm-calls-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 17px; height: 17px; padding: 0 5px; margin-left: 5px;
  font-size: 11px; font-weight: 700; color: #fff; background: #6d5efc; border-radius: 999px;
}
.rm-calls-body { padding: 16px 18px !important; overflow-y: auto; }
.rm-calls { display: flex; flex-direction: column; gap: 12px; }
.rm-call { border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 14px; background: #fff; }
.rm-call__head { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.rm-call__phone { font-size: 14px; font-weight: 700; color: #111827; font-variant-numeric: tabular-nums; }
.rm-call__tag {
  font-size: 11px; font-weight: 700; color: #0b7a4b; background: #e7f8ef;
  border: 1px solid #b8e9cf; border-radius: 999px; padding: 2px 8px;
}
.rm-call__when { margin-left: auto; font-size: 12px; color: #6b7280; }
.rm-call__meta { margin-top: 2px; font-size: 12.5px; color: #6b7280; display: flex; gap: 6px; flex-wrap: wrap; }
.rm-call__norec { margin-top: 8px; font-size: 12px; color: #9ca3af; font-style: italic; }
.rm-call__summary {
  display: flex; align-items: flex-start; gap: 8px; margin-top: 10px;
  padding: 10px 12px; background: #f7f6ff; border: 1px solid #ece9fb; border-radius: 10px;
}
.rm-call__ia {
  flex: none; display: inline-flex; align-items: center; gap: 4px;
  font-size: 10px; font-weight: 800; letter-spacing: 0.03em; color: #6d5efc;
  background: #eceafe; border: 1px solid #dcd9fb; border-radius: 999px; padding: 3px 8px; line-height: 1;
}
.rm-call__ia svg { width: 11px; height: 11px; fill: #6d5efc; }
.rm-call__summary-text { font-size: 13px; line-height: 1.45; color: #374151; }
.rm-rec {
  display: inline-flex; align-items: center; gap: 7px; margin-top: 10px;
  font-size: 13px; font-weight: 600; color: #4b3fd1; background: #eef0ff;
  border: 1px solid #dcd9fb; border-radius: 10px; padding: 8px 14px; cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.rm-rec:hover { background: #e6e4ff; border-color: #6d5efc; }
.rm-rec__ico { font-size: 11px; line-height: 1; }
.rm-player {
  display: flex; align-items: center; gap: 10px; margin-top: 10px;
  padding: 8px 12px; background: #eef0ff; border: 1px solid #dcd9fb; border-radius: 12px;
}
.rm-player__play {
  flex: none; width: 30px; height: 30px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center;
  background: #6d5efc; color: #fff; border: none; cursor: pointer;
  transition: background 0.15s ease, transform 0.08s ease;
}
.rm-player__play:hover:not(:disabled) { background: #5b4be0; }
.rm-player__play:active:not(:disabled) { transform: scale(0.93); }
.rm-player__play:disabled { opacity: 0.65; cursor: default; }
.rm-player__play svg { width: 13px; height: 13px; fill: currentColor; }
.rm-player__spin {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.45); border-top-color: #fff; animation: rmspin 0.7s linear infinite;
}
@keyframes rmspin { to { transform: rotate(360deg); } }
.rm-player__bar { position: relative; flex: 1 1 auto; height: 6px; border-radius: 999px; background: #dcd9fb; cursor: pointer; }
.rm-player__fill { position: absolute; left: 0; top: 0; height: 100%; border-radius: 999px; background: #6d5efc; }
.rm-player__thumb {
  position: absolute; top: 50%; width: 12px; height: 12px; border-radius: 50%;
  background: #fff; border: 2px solid #6d5efc; transform: translate(-50%, -50%);
  box-shadow: 0 1px 3px rgba(76, 63, 209, 0.3); pointer-events: none;
}
.rm-player__time { flex: none; font-size: 11px; font-weight: 600; color: #6b6b8a; font-variant-numeric: tabular-nums; min-width: 64px; text-align: right; }
.rm-player__dl { flex: none; width: 26px; height: 26px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; color: #4b3fd1; text-decoration: none; cursor: pointer; transition: background 0.15s ease; }
.rm-player__dl:hover { background: #e0ddfb; }
.rm-player__dl svg { width: 15px; height: 15px; }

$primary: #22c55e;
$primary-dark: #16a34a;
$secondary: #3b82f6;
$ink-900: #0f172a;
$ink-800: #1f2937;
$ink-700: #334155;
$ink-600: #475569;
$ink-500: #64748b;
$ink-400: #94a3b8;
$bg-soft: #fff;

.reservation-messages,
.rm-panel,
.rm-list-view,
.rm-conversation-view,
.chat-footer,
.search-input,
.chat-preview,
.predefined-item-preview,
.auto-banner-left,
.conversation-alert,
.conversation-status-loading {
  font-family: "DM Sans", sans-serif;
}

.rm-tab,
.chat-name,
.user-name,
.predefined-item-question,
.empty-state h4,
.mode-label.active {
  font-family: "DM Sans", sans-serif;
}

.chat-time,
.window-timer {
  font-family: "DM Sans", sans-serif;
  letter-spacing: 0.01em;
}

.limited-mode-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #ede9fe;
  border-radius: 10px;
  margin: 10px 14px 4px;
  font-size: 12.5px;
  color: #5b21b6;
  font-weight: 500;

  svg {
    color: #7c3aed;
    flex-shrink: 0;
  }
}

.rejected-mode-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fef2f2;
  border-radius: 10px;
  margin: 10px 14px 4px;
  font-size: 12.5px;
  color: #b91c1c;
  font-weight: 500;

  svg {
    color: #dc2626;
    flex-shrink: 0;
  }
}

.link-waba-img {
  flex-shrink: 0;

  .whatsapp-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background: #25d366;
    color: white;
    border-radius: 34px;
    text-decoration: none;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);

    &:hover {
      background: #20ba5a;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

.window-timer {
  display: block;
  font-size: 0.72rem;
  color: #16a34a;
  font-weight: 700;
  margin-top: 2px;
}

.conversation-alerts {
  padding: 8px 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  background: #ffffff;
  border-bottom: 1px solid #eef0f4;
}

/* Barra de aviso: una sola línea pegada al borde del header.
   Si el texto se pasa -> ellipsis y tooltip con la razón completa al hover. */
.ca-bar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  font-family: "DM Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
  border-bottom: 1px solid #eef0f4;

  &.warning {
    background: rgba(255, 87, 34, 0.07);
    color: #e0531d;
    border-bottom-color: rgba(255, 87, 34, 0.16);
  }
  &.error {
    background: #fef2f2;
    color: #c0392b;
    border-bottom-color: #fde0e0;
  }
}

.ca-bar__icon,
.ca-bar__info {
  display: inline-flex;
  flex-shrink: 0;
}
.ca-bar__text {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.ca-bar__info {
  opacity: 0.5;
  transition: opacity 0.16s ease;
}
.ca-bar:hover .ca-bar__info {
  opacity: 1;
}

/* Tooltip con la razón completa, debajo de la barra */
.ca-bar::after {
  content: attr(data-tip);
  position: absolute;
  left: 18px;
  top: calc(100% + 7px);
  z-index: 40;
  width: max-content;
  max-width: 360px;
  padding: 9px 11px;
  border-radius: 10px;
  background: #0e1320;
  color: #fff;
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.45;
  letter-spacing: -0.01em;
  white-space: normal;
  box-shadow: 0 14px 30px -10px rgba(16, 24, 40, 0.45);
  opacity: 0;
  transform: translateY(-4px);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.ca-bar::before {
  content: "";
  position: absolute;
  left: 22px;
  top: calc(100% + 2px);
  z-index: 41;
  border: 5px solid transparent;
  border-bottom-color: #0e1320;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.18s ease;
}
.ca-bar:hover::after {
  opacity: 1;
  transform: translateY(0);
}
.ca-bar:hover::before {
  opacity: 1;
}

.conversation-status-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 0.78rem;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.status-loading-spinner {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid #e5e7eb;
  border-top-color: #3b82f6;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.reservation-messages {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 580px;
}

/* Las pestañas y el panel eran DOS tarjetas blancas apiladas, con 8px de separación
   entre ellas y el padding propio de cada una: mucho blanco muerto arriba y menos sitio
   para el chat. Ahora son UNA sola tarjeta — la barra es la cabecera del panel. */
.rm-header {
  margin-bottom: 0;
}

/* UNA sola fila. Antes hacía `flex-wrap: wrap` y con 5-6 pestañas saltaba a una
   segunda línea: se comía ~44px de alto del panel (que es donde va el chat) y dejaba
   un hueco en blanco a la derecha de la primera fila. Ahora no envuelve nunca y, si
   no caben, se desplazan en horizontal (sin barra visible). */
/* ── El carril de pestañas ────────────────────────────────────────────────────
   Antes las siete encogían a la vez (`flex: 1 1 auto`) hasta que el texto tocaba
   el icono y la insignia, y por debajo de 560px la barra partía en dos filas.
   Ahora cada una conserva su tamaño y, cuando no caben, el carril se desplaza:
   con sus degradados a los lados y sus flechas, para que se vea que hay más.

   El scroll era imposible mientras el estado de los check-ins usara `v-tooltip`
   (la versión 1.x monta el globo pegado al elemento y cualquier `overflow` se lo
   come). Ese pasó al tooltip nativo del navegador y el carril quedó libre. */
.rm-tabs-carril {
  position: relative;
  border-radius: 18px 18px 0 0;
  border-bottom: 1px solid #eef0f4;
  background: #f7f8fb;
  /* Los degradados de los bordes: dicen «sigue habiendo pestañas» sin ocupar sitio.
     Se encienden con las flechas, así que no tapan nada cuando todo cabe. */
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 1px;
    width: 46px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.18s ease;
    z-index: 1;
  }
  &::before {
    left: 0;
    border-radius: 18px 0 0 0;
    background: linear-gradient(to right, #f7f8fb 42%, rgba(247, 248, 251, 0));
  }
  &::after {
    right: 0;
    border-radius: 0 18px 0 0;
    background: linear-gradient(to left, #f7f8fb 42%, rgba(247, 248, 251, 0));
  }
  &.tiene-izq::before,
  &.tiene-der::after {
    opacity: 1;
  }
}

.rm-tabs {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 6px;
  gap: 4px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  /* La barra de scroll se esconde: la pista son los degradados y las flechas. */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { display: none; }
  /* SIN scroll-snap a propósito: con `scrollIntoView` de la pestaña activa el
     navegador volvía a ajustar y la barra daba un salto bajo el cursor — justo lo
     que se venía a arreglar. Lo poco que aportaba no compensa. */
  overscroll-behavior-x: contain;
}

/* Las flechas van ENCIMA del degradado, no dentro del carril: si viajaran con él se
   desplazarían fuera de la vista justo cuando hacen falta. */
.rm-flecha {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #e6e9ef;
  border-radius: 999px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  transition: color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;

  &:hover {
    color: #0a0a0a;
    background: #ffffff;
    box-shadow: 0 3px 12px rgba(15, 23, 42, 0.18);
  }
  &:active { transform: translateY(-50%) scale(0.93); }
  &--izq { left: 5px; }
  &--der { right: 5px; }
}

/* Quien pidió menos movimiento no ve el desplazamiento animado. */
@media (prefers-reduced-motion: reduce) {
  .rm-tabs { scroll-behavior: auto; }
  .rm-flecha { transition: none; }
}

.rm-tab {
  border: none;
  background: transparent;
  padding: 7px 8px;
  border-radius: 12px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  transition: background 0.24s cubic-bezier(0.22, 0.8, 0.32, 1),
    color 0.2s ease, box-shadow 0.24s cubic-bezier(0.22, 0.8, 0.32, 1),
    transform 0.16s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  /* NUNCA encogen: cada una ocupa lo que pide su contenido. Encogerlas para que
     cupieran era el origen del amontonamiento; si no caben, el carril se desplaza. */
  flex: 0 0 auto;
  padding-inline: 12px;
  /* Alto fijo: así todas se alinean aunque sus iconos vengan de componentes
     distintos (SVG suelto, IconOTA…). */
  height: 34px;
  line-height: 1;
}

.rm-tab:not(.active):hover {
  color: #0a0a0a;
}
.rm-tab:active {
  transform: scale(0.97);
}

.rm-tab.active {
  background: #ffffff;
  color: #0a0a0a;
  box-shadow: 0 1px 7px rgba(15, 23, 42, 0.12);
}

/* ── Barra compacta: sección activa + botón de menú ── */
.rm-tabbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 8px 6px 14px;
  background: #ffffff;
  border: 1px solid #eef0f4;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}
.rm-tabbar__current {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.rm-tabbar__wa {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: #25d366;
  color: #fff;
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
}
.rm-tabbar__label {
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #0e1320;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rm-tabbar__menu {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #eef0f4;
  background: #f7f8fb;
  color: #3a4156;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.16s ease;
}
.rm-tabbar__menu:hover {
  background: #eef0f4;
  color: #0e1320;
}

/* ── Drawer lateral derecho de secciones ── */
.rm-drawer-portal {
  position: relative;
}
.rm-drawer-scrim {
  position: fixed;
  inset: 0;
  z-index: 100000; /* por encima de sidebar (1000) y nav (999) */
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  justify-content: flex-end;
}
.rm-drawer {
  width: 300px;
  max-width: 84vw;
  height: 100%;
  background: #ffffff;
  box-shadow: -12px 0 40px rgba(16, 24, 40, 0.18);
  display: flex;
  flex-direction: column;
  padding: 16px;
}

/* Drawer de sección (Check-ins / Cargos / Notas): 50% de la pantalla, con scroll */
.rm-drawer--section {
  width: 50vw;
  max-width: 50vw;
  padding: 0;
}
@media (max-width: 900px) {
  .rm-drawer--section {
    width: 92vw;
    max-width: 92vw;
  }
}
.rm-drawer--section .rm-drawer__head {
  padding: 16px 18px;
  margin-bottom: 0;
}
.rm-drawer__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
}
.rm-drawer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eef0f4;
}
.rm-drawer__head strong {
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #0e1320;
}
.rm-drawer__close {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #eef0f4;
  background: #fff;
  color: #6b7388;
  display: grid;
  place-items: center;
  cursor: pointer;
}
.rm-drawer__close:hover {
  background: #f7f8fb;
  color: #0e1320;
}
.rm-drawer__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rm-drawer__tab {
  width: 100%;
  justify-content: flex-start !important;
  gap: 10px;
  padding: 11px 12px !important;
  border-radius: 11px !important;
  font-size: 14px !important;
}
.rm-drawer__tab.active {
  background: #f0f3ff !important;
  color: #4054c8 !important;
  box-shadow: none !important;
}
.rm-drawer__tab:hover {
  background: #f7f8fb;
}

/* Transición del drawer (Vue 2) */
.rm-drawer-enter-active,
.rm-drawer-leave-active {
  transition: opacity 0.2s ease;
}
.rm-drawer-enter-active .rm-drawer,
.rm-drawer-leave-active .rm-drawer {
  transition: transform 0.24s cubic-bezier(0.22, 0.8, 0.32, 1);
}
.rm-drawer-enter,
.rm-drawer-leave-to {
  opacity: 0;
}
.rm-drawer-enter .rm-drawer,
.rm-drawer-leave-to .rm-drawer {
  transform: translateX(100%);
}

/* ── Check-in status badge ───────────────────────────── */
.checkin-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px 2px 5px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  position: relative;
  cursor: default;
  transition: opacity 0.15s ease;
}

.checkin-status-badge--ok {
  background: #dcfce7;
  color: #16a34a;
}

.checkin-status-badge--manual {
  background: #f3eeff;
  color: #673de6;
}

.checkin-status-badge--pending {
  background: #f1f5f9;
  color: #64748b;
}

.checkin-badge-count {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

/* Tooltip via CSS */
.checkin-status-badge::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 7px);
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: #f8fafc;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 8px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
  transform: translateX(-50%) translateY(4px);
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.checkin-status-badge::before {
  content: '';
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1e293b;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 999;
}

.checkin-status-badge:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.checkin-status-badge:hover::before {
  opacity: 1;
}

/* Todos los iconos de pestaña al MISMO tamaño. Venían de sitios distintos (SVG suelto
   de WhatsApp a 20px, IconOTA a 25px inline) y cada pestaña acababa con un alto
   distinto: la fila se veía desigual. */
.tab-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.tab-icon :deep(svg),
.tab-icon svg {
  width: 17px !important;
  height: 17px !important;
}

/* IconOTA fija su ancho inline con !important: no se puede redimensionar por CSS,
   se encaja escalándolo (misma técnica que en la bandeja del nav). */
.tab-icon :deep(.icon-ota) {
  margin-left: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.68);
  transform-origin: center;
}

.tab-icon-whatsapp svg {
  border-radius: 999px;
}
.tab-icon-whatsapp .link-waba-img,
.tab-icon-whatsapp .whatsapp-btn {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

/* Se llamaba `.rm-body`, la MISMA clase que RerservationModal.vue define en un <style>
   sin `scoped` (`padding: 20px 22px 6px`). Esa regla se colaba aquí y metía 20px de
   hueco muerto entre las pestañas y el chat, más 22px a cada lado que estrechaban la
   conversación. Renombrada para que nadie de fuera la pise. */
.rmc-body {
  flex: 1;
  min-height: 0;
}

.rm-panel {
  height: 100%;
  /* La fila de pestañas ya no envuelve, así que ese alto vuelve al panel: la caja de
     conversación deja de quedarse pequeña con un hueco en blanco encima. */
  min-height: 520px;
  background: #ffffff;
  /* Solo abajo: arriba cierra la barra de pestañas (misma tarjeta). */
  border-radius: 0 0 18px 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* ── Silueta de carga del hilo ───────────────────────────────────
   Reproduce la forma real de la conversación (burbujas alternas) para que al llegar
   los mensajes no cambie el encuadre. */
.chat-skeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 16px;
}

.sk-row {
  display: flex;
}
.sk-row.in {
  justify-content: flex-start;
}
.sk-row.out {
  justify-content: flex-end;
}

.sk-bubble {
  display: block;
  height: 44px;
  border-radius: 14px;
  background: linear-gradient(90deg, #eef1f6 25%, #f6f8fb 37%, #eef1f6 63%);
  background-size: 400% 100%;
  animation: sk-shimmer 1.4s ease-in-out infinite;
}
.sk-row.out .sk-bubble {
  background: linear-gradient(90deg, #e4f2e6 25%, #f0f9f1 37%, #e4f2e6 63%);
  background-size: 400% 100%;
}

@keyframes sk-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* Cambio lista ↔ conversación: la vista que entra se desliza y aparece. Corto (el
   operador está en una tarea, no viendo una animación) y con desaceleración
   exponencial, nunca rebote.

   Es una animación CSS sobre el propio elemento, NO un <transition> de Vue, y a
   propósito: un <transition> deja el nodo saliente colgado si el navegador no avisa
   del fin de la animación (pestaña en segundo plano, ahorro de energía), y con
   `mode="out-in"` la vista nueva ni siquiera llegaría a aparecer. Además va SIN
   fill-mode: el estado en reposo es el normal (visible), así que si las animaciones no
   corren el chat se ve igual — la animación mejora un contenido ya visible, no lo
   condiciona. */
.rm-conversation-view,
.rm-list-view {
  animation: rm-view-in 200ms cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes rm-view-in {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
}

/* Entrada/salida del hilo: un fundido corto con desaceleración exponencial. Sustituye
   al cambio "de golpe" de antes, sin llegar a hacer esperar al operador. */
.rm-fade-enter-active,
.rm-fade-leave-active {
  transition: opacity 180ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 180ms cubic-bezier(0.16, 1, 0.3, 1);
}
.rm-fade-enter,
.rm-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

@media (prefers-reduced-motion: reduce) {
  .sk-bubble,
  .rm-conversation-view,
  .rm-list-view {
    animation: none;
  }
  .rm-fade-enter-active,
  .rm-fade-leave-active {
    transition: opacity 120ms linear;
  }
  .rm-fade-enter,
  .rm-fade-leave-to {
    transform: none;
  }
}

.rm-list-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-soft;
}

.search-bar {
  padding: 10px 14px 6px;
  background: $bg-soft;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $ink-400;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 10px 36px 10px 36px;
  border-radius: 999px;
  border: 1px solid #d7e0eb;
  font-size: 0.9rem;
  font-weight: 500;
  color: $ink-700;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: $ink-400;
  }

  &:focus {
    border-color: #9fc2ff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
  }
}

.clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: $ink-400;
  padding: 0 2px;

  &:hover {
    color: $ink-700;
  }
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 2rem;
  text-align: center;

  .empty-icon {
    margin-bottom: 1.25rem;
    opacity: 0.55;
  }

  .empty-badge {
    width: 60px;
    height: 60px;
    border-radius: 18px;
    display: grid;
    place-items: center;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #e7f7ee 0%, #eef0fc 100%);
    border: 1px solid #ecedf2;
    color: #11b14d;
  }

  h4 {
    color: $ink-900;
    margin-bottom: 6px;
    font-weight: 700;
    font-size: 0.98rem;
    letter-spacing: -0.2px;
    font-family: "DM Sans", sans-serif;
  }

  p {
    color: $ink-500;
    margin: 0;
    max-width: 240px;
    font-size: 0.82rem;
    line-height: 1.5;
    font-family: "DM Sans", sans-serif;
  }
}

.empty-filter {
  padding-top: 2.5rem;
}

.notifications-list {
  padding: 10px 14px 14px;
  overflow-y: auto;
  flex: 1;
  max-height: 100%;
  background: #fcfcfd;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
}

.chat-list-item {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: #ffffff;
  border: 1px solid var(--rsv-line, #ecedf2);
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.03);

  &:hover {
    transform: translateY(-1px);
    border-color: #e0e2ea;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.07);
  }

  &.active {
    border-color: rgba(59, 130, 246, 0.32);
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.1);
  }

  &.unread {
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  }
}

.chat-avatar {
  width: 38px;
  height: 38px;
  border-radius: 90px;
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.chat-main {
  min-width: 0;
  flex: 1;
  position: relative;
  padding-right: 30px;
}

.chat-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 2px;
}

.chat-name {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.25;
  font-weight: 700;
  color: $ink-900;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-time {
  flex-shrink: 0;
  font-size: 0.7rem;
  color: $ink-400;
  font-weight: 700;
  white-space: nowrap;
}

.chat-phone-row {
  margin: 1px 0 3px;
  line-height: 1;
}

.chat-phone {
  font-size: 0.72rem;
  font-weight: 600;
  color: $ink-400;
  letter-spacing: 0.01em;
}

.chat-bottom-row {
  position: relative;
}

.chat-preview {
  margin: 0;
  color: $ink-600;
  font-size: 0.78rem;
  line-height: 1.4;
  padding-right: 16px;
  word-break: break-word;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.chat-mode-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.12);

  &.auto-mode {
    background: #ecfdf3;
    color: #16a34a;
    border: 1px solid #bbf7d0;
  }

  svg {
    width: 15px;
    height: 15px;
    display: block;
  }
}

.chat-unread-dot {
  position: absolute;
  top: 16px;
  right: 14px;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #22c55e;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.12);
}

.bot-modal-footer {
  padding: 8px 14px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}

.icon-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 6px !important;
  border-radius: 999px !important;
}

.icon-btn.outline {
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: $ink-600 !important;

  &:hover {
    border-color: #cbd5e1 !important;
    background: #f9fafb !important;
  }
}

.rm-conversation-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-soft;
  overflow: auto;
}

.chat-header {
  display: flex;
  gap: 12px;
  padding: 14px 18px 12px;
  align-items: center;
  background: #ffffff;
  text-align: left;
  border-bottom: 1px solid #e5ebf3;
}

.back-btn {
  border: none;
  background: #f3f4f6;
  color: $ink-700;
  border-radius: 999px;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.76rem;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.18s ease;

  &:hover {
    background: #e5e7eb;
    color: $ink-900;
    transform: translateX(-1px);
  }
}

.header-center {
  min-width: 0;
  flex: 1;
}

.user-name {
  margin: 0 0 2px 0;
  font-size: 1rem;
  font-weight: 700;
  color: $ink-900;
}

.copy-portal-btn {
  flex-shrink: 0;
  border: 1px solid #cfe8d8;
  background: #eafaf1;
  color: #0e7a3c;
  border-radius: 999px;
  padding: 7px 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    background: #ddf5e7;
    border-color: #12964a;
  }
  &:active { transform: scale(0.96); }
}

.chat-body {
  position: relative;
  flex: 1;
  min-height: 0;
  /* 56px abajo eran un colchón heredado: debajo ya está el pie con el compositor, así
     que solo dejaban un hueco vacío entre el último mensaje y la caja de escribir. */
  padding: 13px 14px 14px;
  overflow-y: auto;
  font-family: "Segoe UI", "Helvetica Neue", Helvetica, "Lucida Grande", Arial, Ubuntu, Cantarell, "Fira Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #eef0f0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
    url("~@/assets/fondo_whatsapp_chat_light.png");
  background-repeat: no-repeat, repeat;
  background-size: 100% 100%, 400px auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
}

.drop-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.drop-overlay-inner {
  border-radius: 20px;
  padding: 32px 40px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.4);
  border: 2px dashed $primary;
  text-align: center;
  color: $ink-700;

  svg {
    margin-bottom: 12px;
    color: $primary;
  }

  .drop-text {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: $ink-900;
  }
}

.messages-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-row {
  display: flex;

  &.user {
    justify-content: flex-start;
  }

  &.assistant {
    justify-content: flex-end;
  }

  &.system {
    justify-content: center;
  }

  // Burbujas consecutivas del mismo emisor: más juntas (estilo WhatsApp)
  &.user + .message-row.user,
  &.assistant + .message-row.assistant {
    margin-top: -2px;
  }
}

.message-card {
  position: relative;
  max-width: 78%;
  padding: 6px 9px 5px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 1px rgba(11, 20, 26, 0.13);
  display: flex;
  flex-direction: column;
  gap: 2px;

  // Entrante (HUÉSPED) — izquierda, blanca, cola arriba-izquierda
  &.user {
    background: #ffffff;
    border-top-left-radius: 0;
    min-width: 92px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -7px;
      width: 0;
      height: 0;
      border: 7px solid transparent;
      border-top-color: #ffffff;
      border-right: 0;
    }
  }

  // Saliente (BOT / STAFF) — derecha, verde WhatsApp, cola arriba-derecha
  &.assistant {
    background: #d9fdd3;
    border-top-right-radius: 0;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: -7px;
      width: 0;
      height: 0;
      border: 7px solid transparent;
      border-top-color: #d9fdd3;
      border-left: 0;
    }
  }

  // Aviso del sistema — pastilla centrada tipo nota de WhatsApp
  &.system {
    background: #ffffff;
    align-items: center;
    text-align: center;
    border-radius: 8px;
    max-width: 88%;
    box-shadow: 0 1px 1px rgba(11, 20, 26, 0.1);

    &::before {
      display: none;
    }
  }

  &.failed-card {
    opacity: 0.92;
    background: #fff7f8;

    &::before {
      border-top-color: #fff7f8;
    }
  }
}

.message-text,
.message-system-text {
  font-size: 14.2px;
  color: #111b21;
  line-height: 1.34;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.message-system-text {
  font-size: 12.5px;
  color: #54656f;
}

.message-media {
  margin-top: 6px;
}

.message-media.image img {
  max-width: 260px;
  max-height: 260px;
  border-radius: 10px;
  display: block;
  object-fit: cover;
}

/* Fotos del Agente IA: hasta cuatro en una burbuja sin descuadrarla. Se respeta
   el ancho de 260px que ya usaban las imágenes sueltas de este panel. */
.message-media.gallery {
  display: grid;
  gap: 5px;
  width: 260px;
  max-width: 100%;
}
.message-media.gallery--grid { grid-template-columns: repeat(2, 1fr); }
.message-media.gallery--three { grid-template-columns: repeat(2, 1fr); }
.message-media.gallery--three .gallery-cell:first-child {
  grid-column: 1 / -1;
  aspect-ratio: 16 / 9;
}
.message-media.gallery--one { grid-template-columns: 1fr; }
.message-media.gallery--one .gallery-cell { aspect-ratio: 4 / 3; }

.gallery-cell {
  position: relative;
  aspect-ratio: 1 / 1;
  min-height: 60px;
  border-radius: 10px;
  overflow: hidden;
  background: #eef2f6;
  display: block;
}
.gallery-cell > a { display: block; width: 100%; height: 100%; }
.gallery-cell img,
.gallery-cell video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.gallery-cell img { transition: opacity 0.16s ease; }
.gallery-cell:hover img { opacity: 0.9; }

@media (max-width: 767px) {
  .message-media.gallery { width: 100%; max-width: 230px; }
}

@media (prefers-reduced-motion: reduce) {
  .gallery-cell img { transition: none; }
  .gallery-cell:hover img { opacity: 1; }
}

.message-media.audio audio,
.message-media.video video {
  width: 260px;
  max-width: 100%;
  outline: none;
}

.message-media.document .doc-link,
.message-attachment a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 8px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 0.78rem;
  text-decoration: none;
}

.message-media.location .location-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 9px;
  border-radius: 10px;
  background: #ecfdf3;
  color: #14532d;
  font-size: 0.8rem;
  text-decoration: none;
  border: 1px solid #bbf7d0;
}

.location-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.location-title {
  font-weight: 600;
}

.location-subtitle {
  font-size: 0.7rem;
  color: #166534;
}

.message-attachments {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.message-meta {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
  align-self: flex-end;
  line-height: 1;
}

// Hora "en línea" estilo WhatsApp: flota abajo-derecha y el texto reserva
// hueco en su última línea. Solo en burbujas de texto (sin media).
.message-card:not(.has-media):not(.system) {
  .message-text {
    padding-right: 48px;
  }

  .message-meta {
    position: absolute;
    right: 9px;
    bottom: 4px;
    margin-top: 0;
  }

  &.assistant .message-text {
    padding-right: 64px;
  }
}

// Etiqueta de remitente (BOT / STAFF · HUÉSPED) arriba, como nombre en WhatsApp
.message-sender {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.1;
  margin-bottom: 1px;
  color: #1f9e88;

  &.user {
    color: #c2792b;
  }
}

.message-delivery-status {
  font-size: 0.8rem;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.22em;

  &--sent,
  &--delivered,
  &--queued {
    color: #8696a0;
  }

  &--read {
    color: #53bdeb;
  }

  &--failed {
    color: #ef4444;
  }
}

.message-time {
  font-size: 0.64rem;
  color: #667781;
  white-space: nowrap;

  &--pending {
    font-style: italic;
  }
}

.message-bubble--failed,
.message-bubble--window-failed {
  background: transparent !important;
}

.message-fail-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  margin-top: 6px;
  padding: 3px 9px 3px 7px;
  border-radius: 999px;
  background: #fef2f2;
  color: #b42318;
  font-size: 11.5px;
  line-height: 1.35;
  font-weight: 500;
  cursor: default;
}
.message-fail-chip__ico {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  opacity: 0.9;
}
.message-fail-chip__label {
  font-weight: 700;
  flex: 0 0 auto;
}
.message-fail-chip__sep {
  opacity: 0.55;
  flex: 0 0 auto;
}
.message-fail-chip__reason {
  color: #9a2b21;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-error-box {
  margin-top: 10px;
  border-radius: 16px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%);

  &__header {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  &__ico {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    color: #e11d48;
  }

  &__title {
    font-size: 11px;
    font-weight: 800;
    color: #9f1239;
    letter-spacing: 0.005em;
  }

  &__text {
    font-size: 11px;
    line-height: 1.5;
    color: #881337;
    margin: 0;
  }

  &__cta {
    margin-top: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    align-self: flex-start;
    padding: 8px 14px;
    border-radius: 999px;
    border: none;
    background: #e11d48;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s ease, opacity 0.15s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      transform: none;
    }

    &--secondary {
      background: #be123c;
    }
  }
}

.typing-dots {
  display: flex;
  gap: 4px;
  align-items: center;

  span {
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: #9ca3af;
    animation: typing 1.4s infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }

  30% {
    transform: translateY(-6px);
    opacity: 1;
  }
}

.chat-footer {
  padding: 10px 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid #e5e7f3;
  background: #ffffff;
}

.mode-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
  font-size: 0.78rem;
}

/* Indicador cuando el Agente IA no está activo para la propiedad */
.agent-off-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 4px;
  padding: 3px 9px;
  border-radius: 999px;
  background: #fff4e5;
  color: #b45309;
  border: 1px solid #fde2bd;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: help;
}
.agent-off-chip svg { flex: 0 0 auto; }

.mode-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: $ink-500;
  font-weight: 500;

  &.active {
    color: $ink-800;
    font-weight: 700;
  }
}

.ai-agent-icon {
  width: 20px;
  height: 20px;
  color: currentColor;
  fill: none;
  flex-shrink: 0;
}

.ai-agent-icon--sm {
  width: 16px;
  height: 16px;
}

:deep(.custom-switch) {
  .p-inputswitch {
    width: 46px;
    height: 24px;
  }

  .p-inputswitch-slider {
    background: #e5e7eb;
    border-radius: 999px;
    transition: background 0.2s ease;

    &:before {
      width: 18px;
      height: 18px;
      left: 3px;
      bottom: 3px;
      background: #ffffff;
      box-shadow: 0 1px 4px rgba(15, 23, 42, 0.45);
      transition: transform 0.2s ease;
    }
  }

  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: rgba($primary, 0.25);

    &:before {
      transform: translateX(22px);
      background: $primary;
    }
  }
}

.mode-wa-link {
  margin-left: auto;
  font-size: 0.78rem;
  color: #0f766e;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    text-decoration: underline;
  }
}

.input-area {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 14px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(148, 163, 184, 0.12);
}

.predefined-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 -8px 32px rgba(15, 23, 42, 0.15);
  border: 1px solid #e5e7eb;
  margin-bottom: 8px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.predefined-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: $ink-600;
  background: #f8fafc;
  border-radius: 14px 14px 0 0;
}

.predefined-list {
  overflow-y: auto;
  max-height: 280px;
  text-align: left;
}

.predefined-item {
  padding: 12px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8fafc;
  }
}

.predefined-item-question {
  font-size: 0.85rem;
  font-weight: 700;
  color: $ink-900;
  margin-bottom: 4px;
}

.predefined-item-preview {
  font-size: 0.75rem;
  color: $ink-500;
  line-height: 1.4;
}

.predefined-empty {
  padding: 20px 14px;
  text-align: center;
  font-size: 0.82rem;
  color: $ink-400;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input-icon-btn {
  width: 38px !important;
  height: 38px;
  border-radius: 10px;
  border: none;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $ink-600;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.18s ease;
  border: 1px solid #e5e7eb;

  &:hover {
    background: #f1f5f9;
    color: $ink-800;
    border-color: #cbd5e1;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.message-input {
  flex: 1;
  min-height: 38px;
  max-height: 120px;
  border: none;
  outline: none;
  resize: none;
  font-size: 0.9rem;
  font-family: "DM Sans", sans-serif;
  color: $ink-900;
  background: transparent;
  line-height: 1.5;
  padding: 8px 0;

  &::placeholder {
    color: $ink-400;
  }
}

.input-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f3f4f6 !important;
}

.send-btn {
  width: 40px !important;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.25);

  &:hover:not(:disabled) {
    background: $primary-dark;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.send-spinner {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  animation: spin 0.7s linear infinite;
}

.attachments-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.attachment-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 0.78rem;
  border: 1px solid #e0e7ff;

  .file-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    font-weight: 500;
  }

  .remove-file-btn {
    background: transparent;
    border: none;
    color: #6366f1;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 2px;
    margin-left: 2px;
  }
}

.auto-banner {
  margin-top: 2px;
  border-radius: 12px;
  padding: 10px 12px;
  background: #f0fdf4;
  display: flex;
  align-items: center;
  gap: 8px;
}

.auto-banner.ota-banner {
  background: #eff6ff;
}

.auto-banner-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  color: #166534;
  font-weight: 600;
}

.ota-banner .auto-banner-left {
  color: #1d4ed8;
}

.hidden-input {
  display: none;
}

@media (max-width: 768px) {
  .rm-panel {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }

  .chat-list-item {
    padding: 12px 13px;
    border-radius: 16px;
  }

  .chat-avatar {
    width: 40px;
    height: 40px;
    font-size: 0.8rem;
  }

  .chat-name {
    font-size: 0.92rem;
  }

  .chat-preview {
    font-size: 0.84rem;
    padding-right: 20px;
  }

  .chat-time {
    font-size: 0.72rem;
  }

  .chat-body {
    padding: 12px 10px;
  }

  .message-card {
    max-width: 82%;
  }

  .attachment-chip .file-name {
    max-width: 120px;
  }
}

/* ===== RTL (arabe): chrome del chat de la reserva. Las colas de las burbujas,
   el padding interno del mensaje y la posicion del meta se dejan para revision visual. */
[dir="rtl"] {
  .rm-calls-count { margin-left: 0; margin-right: 5px; }
  .rm-call__tag .rm-call__when { margin-left: 0; margin-right: auto; }
  .rm-player__thumb .rm-player__time { text-align: left; }
  .search-icon { left: auto; right: 12px; }
  .clear-btn { right: auto; left: 10px; }
  .chat-main { padding-right: 0; padding-left: 30px; }
  .chat-mode-badge { right: auto; left: 0; }
  .chat-unread-dot { right: auto; left: 14px; }
  .chat-header { text-align: right; }
  .agent-off-chip { margin-left: 0; margin-right: 4px; }
  .mode-wa-link { margin-left: 0; margin-right: auto; }
  .predefined-list { text-align: right; }
  .remove-file-btn { margin-left: 0; margin-right: 2px; }
}

</style>
